/* Klistel custom JS — keep all custom JS here (survives theme updates) */
var KLISTEL_FOOTER_LOGO = 'data:image/png;base64,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';
(function () {
  'use strict';

  // Get the Flickity instance the RELIABLE way. Impulse does NOT store it as
  // element.flickity — the correct handle is window.Flickity.data(element).
  function getFlickity(el) {
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      var inst = window.Flickity.data(el);
      if (inst) return inst;
    }
    // Fallbacks just in case
    if (el.flickity) return el.flickity;
    return null;
  }

  function resizeKlistelSliders() {
    document.querySelectorAll('.product-slideshow').forEach(function (ps) {
      var f = getFlickity(ps);
      if (f && typeof f.resize === 'function') {
        f.resize();
      }
    });
  }

  // Flickity may not be initialized the instant window.load fires. Poll briefly
  // until window.Flickity exists AND the instance is attached, then resize.
  function waitForFlickityThenResize() {
    var tries = 0;
    var maxTries = 40; // ~6s at 150ms
    var timer = setInterval(function () {
      tries++;
      var ps = document.querySelector('.product-slideshow');
      var ready = ps && window.Flickity && typeof window.Flickity.data === 'function' && window.Flickity.data(ps);
      if (ready) {
        clearInterval(timer);
        resizeKlistelSliders();
        // A couple of follow-up passes to catch late layout shifts.
        setTimeout(resizeKlistelSliders, 200);
        setTimeout(resizeKlistelSliders, 600);
      } else if (tries >= maxTries) {
        clearInterval(timer);
        resizeKlistelSliders(); // best effort
      }
    }, 150);
  }

  // Move the native "Size chart" trigger out of its default spot (above the
  // price) and place it INSIDE the SIZE variant wrapper, right after the SIZE
  // label, so it renders on the SIZE label row (left = SIZE, right = link).
  // CSS turns .variant-wrapper into a flex row to put them on one line.
  // Done in JS because the link and the SIZE block are separate siblings of a
  // non-flex container, so pure CSS reordering isn't reliable.
  // v7 â€” Some PDPs use Impulse's dropdown-style size selector instead of
  // button-tiles. Coerce the dropdown into the same button-tile look so every
  // PDP renders identically. Strategy:
  //   1. Find any .variant-wrapper for SIZE regardless of data-type.
  //   2. If it's already data-type="button", do nothing (already tiles).
  //   3. If it's a dropdown/swatch, build .klistel-size-tiles inside it from
  //      the native <select>'s <option> list, and proxy clicks back to the
  //      <select> so Impulse fires its variant-change pipeline.
  function normalizeSizeSelector() {
    var wrappers = document.querySelectorAll('.variant-wrapper');
    wrappers.forEach(function (wrapper) {
      var label = wrapper.querySelector('.variant__label');
      if (!label) return;
      var labelText = (label.textContent || '').trim().toLowerCase();
      if (labelText.indexOf('size') === -1) return; // SIZE wrapper only
      if (wrapper.dataset.klistelNormalized === '1') return;

      var dataType = wrapper.getAttribute('data-type') || '';
      // Already a tile group â€” nothing to convert. Just tag it.
      if (dataType === 'button') {
        wrapper.dataset.klistelNormalized = '1';
        return;
      }

      var select = wrapper.querySelector('select');
      if (!select) return;

      // Build the tile group container.
      var tiles = document.createElement('div');
      tiles.className = 'klistel-size-tiles';
      tiles.setAttribute('role', 'radiogroup');
      tiles.setAttribute('aria-label', 'Size');

      Array.prototype.forEach.call(select.options, function (opt) {
        if (!opt.value) return; // skip blank placeholder option if any
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'klistel-size-tile';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', opt.selected ? 'true' : 'false');
        if (opt.selected) btn.classList.add('is-selected');
        if (opt.disabled) {
          btn.classList.add('is-disabled');
          btn.setAttribute('aria-disabled', 'true');
          btn.disabled = true;
        }
        btn.dataset.value = opt.value;
        btn.textContent = opt.textContent.trim();
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          select.value = opt.value;
          // Fire change so Impulse's variant logic picks it up.
          select.dispatchEvent(new Event('change', { bubbles: true }));
          // Update visual state.
          tiles.querySelectorAll('.klistel-size-tile').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
        });
        tiles.appendChild(btn);
      });

      // Hide the native select but keep it in DOM so Impulse continues to read
      // its value during ATC/variant change. Inserting after label keeps
      // semantics intact.
      select.classList.add('klistel-size-select-hidden');
      label.insertAdjacentElement('afterend', tiles);

      // Mirror select changes (e.g. from sticky-bar sheet) back to tiles.
      select.addEventListener('change', function () {
        tiles.querySelectorAll('.klistel-size-tile').forEach(function (b) {
          var match = b.dataset.value === select.value;
          b.classList.toggle('is-selected', match);
          b.setAttribute('aria-checked', match ? 'true' : 'false');
        });
      });

      wrapper.dataset.klistelNormalized = '1';
      // Re-tag so existing CSS that targets data-type="button" still applies.
      wrapper.setAttribute('data-type', 'button');
    });
  }

  function moveSizeChartLink() {
    normalizeSizeSelector(); // v7 — ensure SIZE wrapper looks like tiles first
    var link = document.querySelector('.size-chart__standalone');
    if (!link) return;

    // v7.2 HARDENING: not every PDP renders the SIZE variant as a button group.
    // Some Liquid templates ship size as a DROPDOWN (data-type="select") OR they
    // place the size-chart link OUTSIDE .variant-wrapper entirely. We now find
    // the wrapper by LABEL TEXT ("size") rather than by data-type, and we fall
    // back gracefully if no label exists yet.
    var wrapper = document.querySelector('.variant-wrapper[data-type="button"]');

    // Fallback 1: any .variant-wrapper whose label text contains "size"
    if (!wrapper) {
      var allWrappers = document.querySelectorAll('.variant-wrapper');
      for (var i = 0; i < allWrappers.length; i++) {
        var lbl = allWrappers[i].querySelector('.variant__label, label');
        if (lbl && /size/i.test(lbl.textContent || '')) {
          wrapper = allWrappers[i];
          break;
        }
      }
    }

    // Fallback 2: any variant-input-wrap with data-handle="size"
    if (!wrapper) {
      var sizeInput = document.querySelector('.variant-input-wrap[data-handle="size"], [data-handle="size"]');
      if (sizeInput) wrapper = sizeInput.closest('.variant-wrapper') || sizeInput;
    }

    if (!wrapper) return; // truly no size control — leave link where it is
    if (link.parentElement === wrapper) return; // already moved

    var label = wrapper.querySelector('.variant__label, label');
    if (label) {
      // Insert the link immediately after the SIZE label inside the wrapper.
      label.insertAdjacentElement('afterend', link);
    } else {
      // No label node — just prepend the link to the wrapper so it stays visible.
      wrapper.insertBefore(link, wrapper.firstChild);
    }
    wrapper.classList.add('klistel-size-row'); // CSS hook for the flex row
  }

  // Build the CTA row to match V1: wrap the ADD TO CART button and append a
  // square wishlist HEART button to its right (both in a flex row).
  // The heart is VISUAL-ONLY for now — no wishlist app installed yet. It does
  // not save anything; functional wiring is deferred to the final phase.
  // We also inject a bag icon into the ADD TO CART label.
  function setupCtaRow() {
    var btn = document.querySelector('button[name="add"], .btn.add-to-cart');
    if (!btn) return;
    if (btn.closest('.klistel-cta-row')) return; // already built

    // 1) Wrap the ADD TO CART button in a flex row container.
    var row = document.createElement('div');
    row.className = 'klistel-cta-row';
    btn.parentNode.insertBefore(row, btn);
    row.appendChild(btn);

    // 2) Inject a bag icon at the start of the button label (if not present).
    var label = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (!btn.querySelector('.klistel-bag-icon')) {
      var bag = document.createElement('span');
      bag.className = 'klistel-bag-icon';
      bag.setAttribute('aria-hidden', 'true');
      bag.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
      btn.insertBefore(bag, btn.firstChild);
    }

    // 3) Create the square wishlist HEART button (visual-only).
    var heart = document.createElement('button');
    heart.type = 'button';
    heart.className = 'klistel-wishlist-btn';
    heart.setAttribute('aria-label', 'Add to wishlist');
    heart.setAttribute('data-klistel-wishlist', '');
    heart.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
    // Visual-only toggle: fill the heart on tap so it feels responsive, but it
    // does NOT persist or save to any list yet.
    heart.addEventListener('click', function () {
      heart.classList.toggle('is-active');
    });
    row.appendChild(heart);
  }

  // ===== TAILOR-MADE FIT: secondary CTA + custom-fit bottom sheet =====
  // V1 secondary CTA "WANT A TAILOR-MADE FIT?" (outline/ghost, scissors left,
  // chevron right). It opens a slide-up bottom sheet with a 4-field measurement
  // form (Chest / Waist / Top Length / Bottom Length). On confirm, we add the
  // CURRENTLY SELECTED size variant to cart via /cart/add.js with the four
  // measurements attached as line-item PROPERTIES, so the tailor sees them on
  // the order. The native size tiles handle age sizing; this sheet is custom-fit
  // only (no duplicate size grid).

  // Read the currently selected variant id from Impulse's product <select>.
  function getSelectedVariantId() {
    var sel = document.querySelector('form.product-single__form select[name="id"], form.product-single__form [name="id"]');
    if (sel && sel.value) return sel.value;
    var checked = document.querySelector('.variant-input input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;
    return null;
  }

  // Is a size actually chosen by the shopper? (Impulse pre-selects the first
  // option, so we treat "a value exists" as selected.)
  function isSizeSelected() {
    return !!getSelectedVariantId();
  }

  // Human-readable label of the selected size, for the toast/info.
  function getSelectedSizeLabel() {
    var checked = document.querySelector('.variant-input input[type="radio"]:checked');
    if (checked) {
      var lbl = document.querySelector('label[for="' + checked.id + '"] , .variant__button-label');
      if (checked.value) {
        var byFor = document.querySelector('label[for="' + checked.id + '"]');
        if (byFor) return byFor.textContent.trim();
      }
    }
    var sel = document.querySelector('form.product-single__form select[name="id"]');
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      return sel.selectedOptions[0].textContent.replace(/-.*$/, '').trim();
    }
    return '';
  }

  function buildTailorSheet() {
    if (document.getElementById('klistel-tailor-sheet')) return; // once

    var overlay = document.createElement('div');
    overlay.className = 'klistel-sheet-overlay';
    overlay.id = 'klistel-tailor-sheet';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Tailor-made fit measurements');
    overlay.innerHTML =
      '<div class="klistel-sheet">' +
        '<div class="klistel-sheet-handle"></div>' +
        '<button type="button" class="klistel-sheet-close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<div class="klistel-sheet-header">' +
          '<h2 class="klistel-sheet-title">Tailor-Made Fit</h2>' +
          '<p class="klistel-sheet-subtitle">Crafted to your little one\u2019s exact measurements</p>' +
        '</div>' +
        '<form class="klistel-custom-form" id="klistel-custom-form">' +
          '<div class="klistel-form-row">' +
            '<div class="klistel-field">' +
              '<label for="klistel-chest">Chest</label>' +
              '<div class="klistel-field-input"><input type="number" id="klistel-chest" inputmode="decimal" min="14" max="40" step="0.5" placeholder="22" required><span class="klistel-field-unit">in</span></div>' +
            '</div>' +
            '<div class="klistel-field">' +
              '<label for="klistel-waist">Waist</label>' +
              '<div class="klistel-field-input"><input type="number" id="klistel-waist" inputmode="decimal" min="14" max="40" step="0.5" placeholder="20" required><span class="klistel-field-unit">in</span></div>' +
            '</div>' +
          '</div>' +
          '<div class="klistel-form-row">' +
            '<div class="klistel-field">' +
              '<label for="klistel-top-length">Top Length</label>' +
              '<div class="klistel-field-input"><input type="number" id="klistel-top-length" inputmode="decimal" min="10" max="40" step="0.5" placeholder="16" required><span class="klistel-field-unit">in</span></div>' +
            '</div>' +
            '<div class="klistel-field">' +
              '<label for="klistel-bottom-length">Bottom Length</label>' +
              '<div class="klistel-field-input"><input type="number" id="klistel-bottom-length" inputmode="decimal" min="10" max="40" step="0.5" placeholder="22" required><span class="klistel-field-unit">in</span></div>' +
            '</div>' +
          '</div>' +
          '<div class="klistel-custom-info">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
            '<p>Each garment is tailored to your measurements with a 1-inch growth margin. Delivery may take 2\u20133 extra days for stitching.</p>' +
          '</div>' +
        '</form>' +
        '<div class="klistel-sheet-footer">' +
          '<button type="button" class="klistel-sheet-cta" id="klistel-tailor-cta" disabled>Fill all measurements</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    var sheet = overlay.querySelector('.klistel-sheet');
    var form = overlay.querySelector('#klistel-custom-form');
    var inputs = form.querySelectorAll('input');
    var cta = overlay.querySelector('#klistel-tailor-cta');
    var closeBtn = overlay.querySelector('.klistel-sheet-close');

    function openSheet() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      validate();
    }
    function closeSheet() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    overlay.klistelOpen = openSheet; // expose to the trigger

    // Close interactions: backdrop click, close button, Esc.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeSheet();
    });
    closeBtn.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSheet();
    });

    function allFilled() {
      return Array.prototype.every.call(inputs, function (i) {
        return i.value && parseFloat(i.value) > 0;
      });
    }
    function validate() {
      if (!isSizeSelected()) {
        cta.disabled = true;
        cta.textContent = 'Select a size first';
        return;
      }
      if (allFilled()) {
        cta.disabled = false;
        cta.textContent = 'Add Custom Fit to Cart';
      } else {
        cta.disabled = true;
        cta.textContent = 'Fill all measurements';
      }
    }
    inputs.forEach(function (i) { i.addEventListener('input', validate); });

    // Confirm: add selected variant to cart with measurements as properties.
    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var variantId = getSelectedVariantId();
      if (!variantId) { validate(); return; }

      cta.disabled = true;
      cta.textContent = 'Adding\u2026';

      var payload = {
        id: variantId,
        quantity: 1,
        properties: {
          'Fit': 'Tailor-Made',
          'Chest (in)': document.getElementById('klistel-chest').value,
          'Waist (in)': document.getElementById('klistel-waist').value,
          'Top Length (in)': document.getElementById('klistel-top-length').value,
          'Bottom Length (in)': document.getElementById('klistel-bottom-length').value
        }
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      }).then(function () {
        closeSheet();
        showToast('Custom fit added to cart');
        // Refresh Impulse's cart drawer/count if available, else go to /cart.
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
          try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        }
        setTimeout(function () { window.location.href = '/cart'; }, 900);
      }).catch(function () {
        cta.disabled = false;
        cta.textContent = 'Add Custom Fit to Cart';
        showToast('Could not add — please try again');
      });
    });

    return overlay;
  }

  // Lightweight toast (matches V1 confirmation pattern).
  function showToast(msg) {
    var t = document.getElementById('klistel-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'klistel-toast';
      t.className = 'klistel-toast';
      t.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
      document.body.appendChild(t);
    }
    t.querySelector('span').textContent = msg;
    t.classList.add('is-show');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  // Inject the two V1 info blocks that don't exist in the live theme:
  //   1) ESTIMATED DELIVERY tracker (Ordered/Ready/Delivered)
  //   2) "Why Moms Love This Fabric" feature cards
  // They sit AFTER the CTAs and BEFORE the accordions, matching V1.
  // Markup lives here (not in Liquid) so it survives theme updates (Rule #6).
  // v7.8 — if the info-blocks tracker is already in the DOM but sitting in
  // the WRONG place (e.g. above the size selector because the tailor button
  // had not yet been injected when setupInfoBlocks first ran), move it to
  // the correct anchor. Called whenever the tailor button appears.
  function relocateInfoBlocksIfNeeded() {
    var wrap = document.querySelector('.klistel-info-blocks');
    if (!wrap) return false;
    var tailorBtn = document.querySelector('.klistel-tailor-trigger');
    if (!tailorBtn) return false;
    // If we are already immediately after the tailor button, nothing to do.
    if (tailorBtn.nextElementSibling === wrap) return true;
    tailorBtn.insertAdjacentElement('afterend', wrap);
    return true;
  }

  // v7.10 — the Size selector block lives in Impulse's product-blocks
  // wrapper, ABOVE the CTA form. We want it directly BEFORE the Add to Cart
  // CTA row. Move .klistel-size-row to sit just before .klistel-cta-row.
  // Idempotent. Returns true once placed correctly.
  function relocateSizeRowIfNeeded() {
    var sizeRow = document.querySelector('.klistel-size-row');
    var ctaRow = document.querySelector('.klistel-cta-row');
    if (!sizeRow || !ctaRow) return false;
    // Already directly before the CTA row?
    if (ctaRow.previousElementSibling === sizeRow) return true;
    ctaRow.parentNode.insertBefore(sizeRow, ctaRow);
    return true;
  }

  // v7.9 — the "Why Moms Love This Fabric" metafield block is rendered by
  // Liquid from product.metafields.custom.fabric_features and ends up in
  // Impulse's product-blocks wrapper, ABOVE the size selector. We need it
  // to sit immediately AFTER the Estimated Delivery tracker. Find the
  // wrapping .product-block that contains our .kl-fabric markup and move
  // it into the form right after .klistel-info-blocks. Idempotent.
  function relocateWhyMomsIfNeeded() {
    var fabric = document.querySelector('.kl-fabric');
    if (!fabric) return false;
    var pb = fabric.closest('.product-block');
    if (!pb) return false;
    var info = document.querySelector('.klistel-info-blocks');
    if (!info) return false;
    // tag it so we can find it again quickly and so CSS can target it
    if (!pb.classList.contains('klistel-why-moms-block')) {
      pb.classList.add('klistel-why-moms-block');
    }
    // Already in the right spot?
    if (info.nextElementSibling === pb) return true;
    info.insertAdjacentElement('afterend', pb);
    return true;
  }

  function setupInfoBlocks() {
    // v7.10 — always ensure size row sits directly before the CTA row.
    relocateSizeRowIfNeeded();
    // v7.8 — if a tracker exists already, just re-anchor if needed.
    if (document.querySelector('.klistel-info-blocks')) {
      relocateInfoBlocksIfNeeded();
      relocateWhyMomsIfNeeded();
      return;
    }

    // v7.3 ANCHOR PRIORITY (matches V1):
    //   1) AFTER the "Want a Tailor-Made Fit?" button (.klistel-tailor-trigger)
    //   2) else AFTER the primary CTA row (.klistel-cta-row)
    //   3) else BEFORE the "Why Moms Love" metafield block
    //   4) else BEFORE the first tab/accordion (legacy)
    // Mode "afterAnchor" inserts via anchor.insertAdjacentElement('afterend', wrap)
    // Mode "beforeAnchor" inserts via anchor.parentNode.insertBefore(wrap, anchor)
    var anchor = null;
    var mode = 'afterAnchor';

    var tailorBtn = document.querySelector('.klistel-tailor-trigger');
    if (tailorBtn) {
      anchor = tailorBtn;
      mode = 'afterAnchor';
    }
    if (!anchor) {
      var ctaRow = document.querySelector('.klistel-cta-row');
      if (ctaRow) {
        anchor = ctaRow;
        mode = 'afterAnchor';
      }
    }
    if (!anchor) {
      var whyMomsBlock = null;
      var allBlocks = document.querySelectorAll('.product-single__meta .product-block, [data-product-blocks] .product-block');
      for (var i = 0; i < allBlocks.length; i++) {
        var txt = (allBlocks[i].textContent || '').toLowerCase();
        if (txt.indexOf('why moms love') !== -1) {
          whyMomsBlock = allBlocks[i];
          break;
        }
      }
      if (whyMomsBlock) {
        anchor = whyMomsBlock;
        mode = 'beforeAnchor';
      }
    }
    if (!anchor) {
      var firstTab = document.querySelector('.product-block--tab');
      if (firstTab) {
        anchor = firstTab;
        mode = 'beforeAnchor';
      }
    }
    if (!anchor) return;

    var wrap = document.createElement('div');
    wrap.className = 'klistel-info-blocks product-block';

    var truckSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var checkSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var boxSvg =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>';

    var trackerHtml =
      '<div class="klistel-tracker">' +
        '<div class="klistel-tracker__title">' + truckSvg + '<span>Estimated Delivery</span></div>' +
        '<div class="klistel-tracker__steps">' +
          '<div class="klistel-tracker__step">' +
            '<div class="klistel-tracker__dot is-done">' + checkSvg + '</div>' +
            '<span class="klistel-tracker__label">Ordered</span>' +
            '<span class="klistel-tracker__date">Today</span>' +
          '</div>' +
          '<div class="klistel-tracker__step">' +
            '<div class="klistel-tracker__dot">' + boxSvg + '</div>' +
            '<span class="klistel-tracker__label">Ready</span>' +
            '<span class="klistel-tracker__date">1–2 days</span>' +
          '</div>' +
          '<div class="klistel-tracker__step">' +
            '<div class="klistel-tracker__dot">' + truckSvg + '</div>' +
            '<span class="klistel-tracker__label">Delivered</span>' +
            '<span class="klistel-tracker__date">5–9 days</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    // Feature cards in V1-screenshot order.
    var cards = [
      {
        // Built to Grow — clock icon
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',
        title: 'Built to Grow',
        body: '1–2″ of expansion margin in every garment — lasts through growth spurts'
      },
      {
        // Pure Chanderi Fabric — heart icon
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
        title: 'Pure Chanderi Fabric',
        body: 'Lightweight, luxurious weave with a natural sheen that drapes beautifully on little ones'
      },
      {
        // Organic Mulmul Lining — smile icon
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>',
        title: 'Organic Mulmul Lining',
        body: "Breathable cotton lining that's gentle on sensitive skin — no itching, no rashes"
      },
      {
        // Swarovski Lace Dupatta — star icon
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
        title: 'Swarovski Lace Dupatta',
        body: 'Flowing organza dupatta with sparkling Swarovski lace trim for that royal finish'
      }
    ];
    var cardsHtml = cards.map(function (c) {
      return '<div class="klistel-feature">' +
        '<div class="klistel-feature__icon">' + c.icon + '</div>' +
        '<div class="klistel-feature__text"><h4>' + c.title + '</h4><p>' + c.body + '</p></div>' +
      '</div>';
    }).join('');

    // DISABLED 2026-06-23: the "Why Moms Love This Fabric" section is now
    // rendered by Shopify Admin (product metafield in product.salwar.json),
    // so the JS-injected version was duplicating. We keep the tracker only.
    // var fabricHtml =
    //   '<section class="klistel-fabric">' +
    //     '<h2 class="klistel-fabric__title">Why Moms Love This Fabric</h2>' +
    //     '<div class="klistel-fabric__list">' + cardsHtml + '</div>' +
    //   '</section>';

    wrap.innerHTML = trackerHtml; // tracker only; fabric section comes from Liquid metafield now
    if (mode === 'afterAnchor') {
      anchor.insertAdjacentElement('afterend', wrap);
    } else {
      anchor.parentNode.insertBefore(wrap, anchor);
    }
    // v7.9 — immediately try to relocate the metafield-rendered
    // "Why Moms Love This Fabric" block to sit right after the tracker.
    relocateWhyMomsIfNeeded();
  }

  // Inject the two V1 social-proof sections that don't exist in the live
  // theme, placed BEFORE the "You May Also Like" recommendations:
  //   1) "Made for Moments That Matter" occasions banner
  //   2) "Words From Our Mothers" review cards (horizontal scroll)
  // Markup lives here so it survives theme updates (Rule #6).
  function setupSocialProof() {
    if (document.querySelector('.klistel-social')) return; // once
    // Anchor: the product-recommendations section ("You May Also Like").
    var rec = document.querySelector(
      '#shopify-section-template--27012273439029__product-recommendations'
    ) || document.querySelector('product-recommendations');
    var recSection = rec ? rec.closest('.shopify-section') || rec : null;
    if (!recSection || !recSection.parentNode) return;

    function star(muted) {
      return '<svg viewBox="0 0 20 20" class="klistel-star' +
        (muted ? ' is-muted' : '') + '"><path d="M10 1l2.39 4.84 5.34.78-3.87 3.77.91 5.32L10 13.27l-4.77 2.51.91-5.32L2.27 6.69l5.34-.78z"/></svg>';
    }
    function stars(filled) {
      var out = '';
      for (var i = 0; i < 5; i++) out += star(i >= filled);
      return out;
    }
    var tick =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

    var reviews = [
      { filled: 5, text: "As a mother, I can't express how thankful I am for the quick 24-hour delivery \u2014 this made everything easier in a time I needed it most.", name: 'Reena Nehra', city: 'Delhi' },
      { filled: 5, text: 'I asked them to customise for me and my daughter and they just asked for 4 measurements and we both rocked.', name: 'Manvi Singh', city: 'Mumbai' },
      { filled: 5, text: "Mom, first time you got something which is not itchy \u2014 these were my daughter's words. Loved the mulmul lining.", name: 'Gitanjali Lokhande', city: 'Pune' },
      { filled: 4, text: 'The kurti was tight on my daughter but there were extra margins, about two inches, and I just opened the sides. Highly recommend this brand.', name: 'Simran Joshi', city: 'Jaipur' },
      { filled: 5, text: 'I was so impressed with the customer service. They delivered the garment to my door the same day. The team was very friendly and helpful.', name: 'Adya Sharma', city: 'Delhi NCR' }
    ];
    var reviewCards = reviews.map(function (r) {
      return '<div class="klistel-review">' +
        '<div class="klistel-review__stars">' + stars(r.filled) + '</div>' +
        '<p class="klistel-review__text">\u201C' + r.text + '\u201D</p>' +
        '<div class="klistel-review__meta">' +
          '<div><div class="klistel-review__author">' + r.name + '</div>' +
          '<div class="klistel-review__city">' + r.city + '</div></div>' +
          '<span class="klistel-review__badge">' + tick + 'Verified Purchase</span>' +
        '</div>' +
      '</div>';
    }).join('');

    var tags = ['Festival', 'Wedding', 'Skin-Safe', 'Artisan Made', 'Customisable'];
    var tagHtml = tags.map(function (t) {
      return '<span class="klistel-occasion-tag">' + t + '</span>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.className = 'klistel-social';
    // [2026-06-21] SWAP ORDER: 'Words From Our Mothers' now comes first,
    // then 'Made for Moments That Matter' below it (per Vivek).
    wrap.innerHTML =
      '<section class="klistel-reviews" id="klistel-reviews">' +
        '<div class="klistel-reviews__header">' +
          '<h2 class="klistel-reviews__title">Words From Our Mothers</h2>' +
          '<span class="klistel-reviews__count">7 reviews</span>' +
        '</div>' +
        '<div class="klistel-reviews__scroll">' + reviewCards + '</div>' +
      '</section>' +
      '<div class="klistel-moments">' +
        '<h3 class="klistel-moments__title">Made for Moments<br>That Matter</h3>' +
        '<p class="klistel-moments__sub">Whether it\u2019s Diwali, Eid, a family wedding, or a festive gathering \u2014 dress her in tradition woven with love.</p>' +
        '<div class="klistel-occasion-tags">' + tagHtml + '</div>' +
      '</div>';

    recSection.parentNode.insertBefore(wrap, recSection);
  }

  // --------------------------------------------------------------------------
  // COMPLETE THE LOOK — a curated accessories row (hairband / bracelet / bag)
  // that the shopper can quick-add WITHOUT leaving the suit page.
  //
  // • Placement: inserted right BEFORE the "Made for Moments" block
  //   (.klistel-social), which itself sits before the recommendations section.
  //   In the DOM that puts this section AFTER the product FAQ/accordions and
  //   ABOVE "Made for Moments That Matter" — exactly where it was requested.
  // • Data: a HAND-PICKED static set (variant IDs hardcoded below). To swap a
  //   product later, just change its variantId / title / price / img / handle.
  //   Find a variant id via:  /products/<handle>.json  -> variants[0].id
  // • Add behaviour: Shopify's native /cart/add.js (theme-independent), then
  //   our existing toast — the shopper STAYS on the page (no drawer). We also
  //   dispatch Impulse's documented 'cart:build' event so the theme's cart
  //   count / drawer stay in sync without touching any theme code (Rule #6).
  // --------------------------------------------------------------------------
  // Hardcoded fallback list â€” used only when the product has no
  // custom.complete_the_look metafield set in Shopify admin. This keeps
  // the section visible during the rollout phase while merchants populate
  // the new per-product metafield. To disable the fallback entirely, set
  // KLISTEL_COMPLETE_LOOK_FALLBACK = []; below.
  var KLISTEL_COMPLETE_LOOK_FALLBACK = [
    {
      label: 'Hairband',
      title: 'Sunehri Hair Accessory',
      price: 1500,
      variantId: 51149902184757,
      handle: 'sunehri-hair-accessory-for-girls',
      img: 'https://cdn.shopify.com/s/files/1/0757/8442/1685/files/Luxury_golden_sequin_headband_for_teens_ethnic_outfits_salwar_suit_lehenga_in_Gurgaon.jpg?v=1761835500'
    },
    {
      label: 'Bracelet',
      title: 'Sunheri Hand Bracelet',
      price: 999,
      variantId: 51155816644917,
      handle: 'sunheri-hand-bracelet-for-girls',
      img: 'https://cdn.shopify.com/s/files/1/0757/8442/1685/files/Golden_hand_bracelet_for_girls_to_pair_with_ethnic_wear_like_lehenga_sharara_suit_salwar.jpg?v=1759512220'
    },
    {
      label: 'Mini Handbag',
      title: 'Bella Handbag',
      price: 1999,
      variantId: 49210167591221,
      handle: 'bella-handbag',
      img: 'https://cdn.shopify.com/s/files/1/0757/8442/1685/files/BELLA_handbags_for_girls_kids.jpg?v=1759512910'
    }
  ];

  // Resolve the Complete-the-Look list. Order of precedence:
  //   1) Per-product metafield exposed by theme.liquid as a JSON script tag
  //      <script type="application/json" id="klistel-ctl-data">[ ... ]</script>
  //      Each entry: { id, title, url, type, image, price (money string), available, variantId }
  //   2) Hardcoded fallback above (legacy/dummy)
  // Returns an array shaped to the renderer's expected schema:
  //   { label, title, price (number paise|rupees), variantId, handle, img }
  function resolveCompleteLookList() {
    var tag = document.getElementById('klistel-ctl-data');
    if (!tag) return KLISTEL_COMPLETE_LOOK_FALLBACK;
    var raw;
    try {
      raw = JSON.parse((tag.textContent || '').trim());
    } catch (e) {
      return KLISTEL_COMPLETE_LOOK_FALLBACK;
    }
    if (!Array.isArray(raw) || raw.length === 0) {
      return KLISTEL_COMPLETE_LOOK_FALLBACK;
    }
    // Map Shopify product objects â†’ renderer shape.
    return raw.map(function (p) {
      // ---- PRICE -----------------------------------------------------
      // Prefer the raw integer `priceCents` (Shopify stores prices in the
      // currency's smallest unit â€” paise/cents). Divide by 100 for rupees.
      // Fallback: parse the money-formatted string "\u20B91,500.00" by
      // stripping non-digits and dividing by 100 when decimals exist.
      var num = 0;
      if (typeof p.priceCents === 'number' && p.priceCents > 0) {
        num = Math.round(p.priceCents / 100);
      } else if (typeof p.price === 'string') {
        var digits = p.price.replace(/[^0-9]/g, '');
        num = parseInt(digits, 10) || 0;
        // If formatted with decimals (e.g. "1,500.00"), divide by 100.
        if (/[.]\d{2}(?!\d)/.test(p.price)) num = Math.round(num / 100);
      } else if (typeof p.price === 'number') {
        num = p.price;
      }

      // ---- HANDLE ----------------------------------------------------
      var handle = '';
      if (p.url) {
        var m = String(p.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }

      // ---- LABEL (the pink/white badge text) -------------------------
      // Priority order so merchants can control it without changing code:
      //   1) A tag starting with "label:" (e.g. "label:Hairband") â€” explicit.
      //   2) The FIRST tag that isn't a system flag (skip filter/category
      //      meta tags starting with underscore or common stop-words).
      //   3) Fall back to product.type (e.g. "Ethnic Wear") if no usable tag.
      //   4) Empty string â€” badge will be hidden by the renderer.
      var label = '';
      var tags = [];
      if (typeof p.tags === 'string' && p.tags.length) {
        tags = p.tags.split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      } else if (Array.isArray(p.tags)) {
        tags = p.tags.slice();
      }
      // (1) explicit label:Xyz tag wins
      for (var t = 0; t < tags.length; t++) {
        var tg = tags[t];
        if (/^label\s*:/i.test(tg)) {
          label = tg.replace(/^label\s*:\s*/i, '').trim();
          break;
        }
      }
      // (2) first non-system tag
      if (!label) {
        var SKIP = /^(_|new\b|sale\b|featured\b|bestseller\b|hidden\b|filter[-_]|category[-_])/i;
        for (var u = 0; u < tags.length; u++) {
          if (!SKIP.test(tags[u])) { label = tags[u]; break; }
        }
      }
      // (3) product type fallback
      if (!label) label = p.type || '';

      return {
        label: label,
        title: p.title || '',
        price: num,
        priceFormatted: typeof p.price === 'string' ? p.price : null,
        variantId: p.variantId,
        handle: handle,
        img: p.image || '',
        available: p.available !== false
      };
    });
  }

  // Single source of truth for the renderer below.
  var KLISTEL_COMPLETE_LOOK = resolveCompleteLookList();

  function inr(n) {
    // Format like ₹1,999 — Indian grouping, no decimals.
    return '\u20B9' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function addAccessoryToCart(item, btn) {
    if (!item.variantId) { showToast('Item unavailable'); return; }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: item.variantId, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function () {
      btn.textContent = 'Added';
      showToast(item.title + ' added to cart');
      // Ask Impulse to refresh its cart (count bubble / drawer) — documented
      // public event, no theme edit. Harmless if the theme version lacks it.
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
      setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1600);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = original;
      showToast('Could not add \u2014 please try again');
    });
  }

  function setupCompleteLook() {
    if (document.querySelector('.klistel-complete')) return; // once
    // Anchor: the "Made for Moments" block. If it isn't injected yet, bail —
    // setupSocialProof runs first in every init path, so on a normal load it
    // exists; the re-run/observer paths will catch it otherwise.
    var social = document.querySelector('.klistel-social');
    if (!social || !social.parentNode) return;

    var cards = KLISTEL_COMPLETE_LOOK.map(function (it) {
      return '<article class="klistel-cl-card">' +
          '<a class="klistel-cl-media" href="/products/' + it.handle + '" aria-label="' + it.title + '">' +
            '<img src="' + it.img + '" alt="' + it.title + '" loading="lazy">' +
            '<span class="klistel-cl-tag">' + it.label + '</span>' +
          '</a>' +
          '<div class="klistel-cl-body">' +
            '<a class="klistel-cl-name" href="/products/' + it.handle + '">' + it.title + '</a>' +
            '<div class="klistel-cl-row">' +
              '<span class="klistel-cl-price">' + inr(it.price) + '</span>' +
              '<button type="button" class="klistel-cl-add" data-variant="' + it.variantId + '">Add</button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');

    var wrap = document.createElement('section');
    wrap.className = 'klistel-complete';
    wrap.innerHTML =
      '<div class="klistel-cl-head">' +
        '<h2 class="klistel-cl-title">Complete the Look</h2>' +
        '<p class="klistel-cl-sub">Handpicked accessories to pair with this suit.</p>' +
      '</div>' +
      '<div class="klistel-cl-scroll">' + cards + '</div>';

    // Wire the Add buttons.
    wrap.querySelectorAll('.klistel-cl-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.getAttribute('data-variant'), 10);
        var item = KLISTEL_COMPLETE_LOOK.filter(function (x) { return x.variantId === vid; })[0];
        if (item) addAccessoryToCart(item, btn);
      });
    });

    // Insert ABOVE "Made for Moments".
    social.parentNode.insertBefore(wrap, social);
  }

  // Enhance the live Impulse footer to match the V1 design WITHOUT touching
  // the theme markup: we keep the merchant's real columns (CUSTOMER CARE /
  // CONTACT US / newsletter) and live copyright untouched, and only INJECT
  // the two V1 pieces that don't exist in the live DOM:
  //   1) a brand header (KLISTEL wordmark + italic tagline + description)
  //      prepended inside .site-footer .page-width
  //   2) a "SECURE CHECKOUT" payment-chip row + "Made in India" line,
  //      inserted just above the existing copyright text.
  // The blush background, Cormorant headings and warm dividers are applied
  // purely via CSS ([17] in custom.css), scoped to .site-footer.
  function setupFooter() {
    var footer = document.querySelector('.site-footer');
    if (!footer) return;
    footer.classList.add('klistel-footer'); // CSS hook for V1 styling
    var pageWidth = footer.querySelector('.page-width') || footer;

    // ---- 1) Brand header (logo image + tagline + desc) ----
    if (!footer.querySelector('.klistel-footer-brand')) {
      var brand = document.createElement('div');
      brand.className = 'klistel-footer-brand';
      // Footer brand uses the official KLISTEL wordmark logo (charcoal version
      // of the header artwork) embedded as a self-contained data URI so it
      // matches the header logo exactly, reads on the light footer background,
      // and lives entirely inside this JS asset (no theme/admin upload, and it
      // survives theme updates per the one-asset rule).
      var logoSrc = KLISTEL_FOOTER_LOGO;
      brand.innerHTML =
        '<a href="/" class="klistel-footer-logo-link" aria-label="KLISTEL home">' +
          '<img class="klistel-footer-logo-img" src="' + logoSrc + '" alt="KLISTEL" width="951" height="120" loading="lazy">' +
        '</a>' +
        '<p class="klistel-footer-tagline">Handcrafted in India with love</p>' +
        '<p class="klistel-footer-desc">Premium ethnic &amp; western kids girls wear. ' +
        'Heirloom-quality lehangas, dresses &amp; festive sets, made in-house with precision.</p>';
      pageWidth.insertBefore(brand, pageWidth.firstChild);
    }

    // ---- 1b) Ensure live footer columns are expanded + clickable ----
    // Impulse renders footer columns as collapsibles. When a panel is in its
    // collapsed state (height:0 / aria-hidden) its links are not clickable.
    // We force every footer collapsible OPEN so all links work on every
    // breakpoint. This only changes runtime state \u2014 no theme markup edits.
    // forceOpenPanels() is called repeatedly (now + on a short interval + via
    // a MutationObserver) because Impulse's own collapsible widget initialises
    // AFTER our script and re-collapses these panels (it sets height:0 inline
    // and re-adds the --small class). On mobile the theme rule
    // `.collapsible-content--small { height:0 }` hides the inner content, which
    // is why Customer Care / Contact Us / Newsletter rendered blank while the
    // JS-built SHOP column showed fine. We strip --small, clear the inline
    // height, and keep re-applying so any re-collapse is immediately undone.
    // Idempotent: only writes when a value actually needs changing, so it
    // never produces a mutation when nothing is collapsed. _foObserver is
    // disconnected around our own writes to avoid self-triggering loops.
    var _foObserver = null;
    function forceOpenPanels() {
      if (_foObserver) _foObserver.disconnect();
      footer.querySelectorAll('.collapsible-content').forEach(function (panel) {
        // Once a panel has been unwrapped (content lifted out), leave it hidden.
        if (panel.getAttribute('data-klistel-unwrapped') === '1') return;
        if (panel.classList.contains('collapsible-content--small')) panel.classList.remove('collapsible-content--small');
        if (!panel.classList.contains('collapsible-content--all')) panel.classList.add('collapsible-content--all');
        if (panel.style.height !== 'auto') panel.style.height = 'auto';
        if (panel.style.maxHeight !== 'none') panel.style.maxHeight = 'none';
        if (panel.style.overflow !== 'visible') panel.style.overflow = 'visible';
        if (panel.getAttribute('aria-hidden') !== 'false') panel.setAttribute('aria-hidden', 'false');
      });
      footer.querySelectorAll('.collapsible-trigger').forEach(function (trig) {
        if (!trig.classList.contains('is-open')) trig.classList.add('is-open');
        if (trig.getAttribute('aria-expanded') !== 'true') trig.setAttribute('aria-expanded', 'true');
        // V1 footer has NO chevrons \u2014 the columns are always open, not
        // accordions. Neutralise the trigger so a tap can't collapse it again
        // and remove the chevron icon node entirely.
        if (!trig.classList.contains('klistel-no-collapse')) trig.classList.add('klistel-no-collapse');
        if (trig.getAttribute('aria-disabled') !== 'true') trig.setAttribute('aria-disabled', 'true');
        var icon = trig.querySelector('.collapsible-trigger__icon');
        if (icon && icon.parentNode) icon.parentNode.removeChild(icon);
      });
      if (_foObserver) {
        footer.querySelectorAll('.collapsible-content').forEach(function (panel) {
          _foObserver.observe(panel, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
        });
      }
    }
    forceOpenPanels();
    // Re-apply for a couple of seconds to outlast the theme's collapsible init.
    var _foCount = 0;
    var _foTimer = setInterval(function () {
      forceOpenPanels();
      if (++_foCount >= 20) clearInterval(_foTimer); // ~2s at 100ms
    }, 100);
    // And catch any later re-collapse (height/class toggling) via observer.
    if (window.MutationObserver) {
      _foObserver = new MutationObserver(function () { forceOpenPanels(); });
      footer.querySelectorAll('.collapsible-content').forEach(function (panel) {
        _foObserver.observe(panel, { attributes: true, attributeFilter: ['style', 'class', 'aria-hidden'] });
      });
    }

    // ---- 1b-2) BULLETPROOF: lift the panel content OUT of the collapsible ----
    // The force-open above relies on beating Impulse's collapse CSS, which can
    // lose on the live theme (Contact Us + newsletter rendered blank). Instead
    // of fighting specificity, we physically move each collapsible panel's
    // inner content up to sit as a direct child of the footer column, then
    // collapse the now-empty original wrapper to zero. Once the content is no
    // longer inside .collapsible-content, NOTHING the theme does can hide it.
    footer.querySelectorAll('.collapsible-content').forEach(function (panel) {
      if (panel.getAttribute('data-klistel-unwrapped') === '1') return;
      var inner = panel.querySelector('.collapsible-content__inner');
      if (!inner) return;
      var holder = document.createElement('div');
      holder.className = 'klistel-footer-open';
      // move every child of the inner wrapper into our always-visible holder
      while (inner.firstChild) holder.appendChild(inner.firstChild);
      // insert the holder right after the (now-empty) collapsible panel
      if (panel.parentNode) {
        panel.parentNode.insertBefore(holder, panel.nextSibling);
      }
      // hide the emptied original wrapper so it leaves no gap
      panel.style.display = 'none';
      panel.setAttribute('data-klistel-unwrapped', '1');
    });

    // Tag the footer grid so our CSS can lay it out like V1 (Customer Care +
    // Shop side-by-side, Contact Us full width, newsletter card full width).
    var gridEl = footer.querySelector('.grid');
    if (gridEl) gridEl.classList.add('klistel-footer-grid');

    // ---- 1c) Inject the missing V1 "SHOP" column ----
    // The live footer has no Shop menu; V1 lists one. We add it inside the
    // existing .grid (after the first column) so it sits alongside the
    // merchant's real columns without altering them.
    var grid = footer.querySelector('.grid');
    if (grid && !footer.querySelector('.klistel-footer-shop')) {
      var shopLinks = [
        ['Lehangas', 'https://klistel.com/collections/lehanga'],
        ['Dresses', 'https://klistel.com/collections/dresses'],
        ['Sharara Sets', 'https://klistel.com/collections/sharara-sets'],
        ['Mom & Daughter Twinning', 'https://klistel.com/collections/mom-daughter-twinning'],
        ['All Collections', 'https://klistel.com/collections/all']
      ];
      var linkHtml = shopLinks.map(function (l) {
        return '<li><a href="' + l[1] + '">' + l[0] + '</a></li>';
      }).join('');

      var shopCol = document.createElement('div');
      // reuse Impulse grid + footer item classes so it matches column widths
      shopCol.className = 'grid__item klistel-footer-shop';
      shopCol.setAttribute('data-type', 'menu');
      shopCol.innerHTML =
        '<h2 class="h4 footer__title">SHOP</h2>' +
        '<div class="footer__collapsible">' +
          '<ul class="no-bullets site-footer__linklist">' + linkHtml + '</ul>' +
        '</div>';
      // Insert as the second column (after CUSTOMER CARE).
      var firstCol = grid.children[0];
      if (firstCol && firstCol.nextSibling) {
        grid.insertBefore(shopCol, firstCol.nextSibling);
      } else {
        grid.appendChild(shopCol);
      }
    }

    // ---- 1c-2) Tag each footer column by role so CSS grid can place them ----
    // V1 layout: row 1 = Customer Care + Shop side-by-side; row 2 = Contact Us
    // (full width); row 3 = newsletter card (full width). We tag columns by
    // their heading text / data-type \u2014 no markup added beyond hook classes.
    if (grid) {
      Array.prototype.forEach.call(grid.children, function (col) {
        if (col.classList.contains('klistel-footer-shop')) {
          col.classList.add('kl-col-shop');
          return;
        }
        var type = (col.getAttribute('data-type') || '').toLowerCase();
        var heading = (col.querySelector('.footer__title') || {}).textContent || '';
        heading = heading.trim().toUpperCase();
        if (type === 'newsletter' || heading.indexOf('BE THE FIRST') !== -1) {
          col.classList.add('kl-col-newsletter');
        } else if (heading.indexOf('CONTACT') !== -1) {
          col.classList.add('kl-col-contact');
        } else if (heading.indexOf('CUSTOMER') !== -1 || heading.indexOf('CARE') !== -1) {
          col.classList.add('kl-col-care');
        }
      });
    }

    // ---- 1c-3) Make the newsletter match V1 exactly ----
    // V1: "THE INNER CIRCLE" rose eyebrow, an ITALIC serif heading "Be the
    // First to Know" (NOT the theme's all-caps), and a specific subtext line.
    // We add the eyebrow, rewrite the heading text, and rewrite the subtext.
    var nlCol = footer.querySelector('.kl-col-newsletter');
    if (nlCol) {
      // (a) eyebrow
      if (!nlCol.querySelector('.klistel-inner-circle')) {
        var eyebrow = document.createElement('div');
        eyebrow.className = 'klistel-inner-circle';
        eyebrow.textContent = 'The Inner Circle';
        var nlHeading0 = nlCol.querySelector('.footer__title.small--hide') || nlCol.querySelector('.footer__title');
        if (nlHeading0 && nlHeading0.parentNode) {
          nlHeading0.parentNode.insertBefore(eyebrow, nlHeading0);
        } else {
          nlCol.insertBefore(eyebrow, nlCol.firstChild);
        }
      }
      // (b) heading text \u2014 force V1 mixed-case (CSS handles the italic serif)
      Array.prototype.forEach.call(nlCol.querySelectorAll('.footer__title'), function (h) {
        if (/be the first to know/i.test(h.textContent)) h.textContent = 'Be the First to Know';
      });
      // (c) subtext \u2014 match V1 copy
      var nlSub = nlCol.querySelector('p');
      if (nlSub) nlSub.textContent = 'Heirloom drops, limited editions & festive pre-launches \u2014 delivered quietly.';
    }

    // ---- 1d) Normalise the CONTACT US links (consistent SVG icon + font) ----
    // The live Contact Us column ships three links (email, WhatsApp, address)
    // each with a raster PNG icon (.ftl_log). The PNGs vary in weight/size and
    // sit top-aligned, so the column reads as a different style from the rest
    // of the footer. We hide the PNGs and prepend a consistent inline SVG that
    // matches the footer's hairline-stroke icon language, then mark the link so
    // CSS can centre icon + text and force the DM Sans treatment. No theme
    // markup is edited \u2014 we only swap presentation on existing nodes.
    var contactIcons = {
      mail: '<svg viewBox="0 0 24 24" class="klistel-contact-svg" aria-hidden="true" focusable="false"><g fill="none" stroke="#D3908A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6 8.5-6"/></g></svg>',
      phone: '<svg viewBox="0 0 24 24" class="klistel-contact-svg" aria-hidden="true" focusable="false"><path fill="none" stroke="#D3908A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M6.5 3.5h3l1.5 4-2 1.5a12 12 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.5 5.5a2 2 0 0 1 2-2Z"/></svg>',
      pin: '<svg viewBox="0 0 24 24" class="klistel-contact-svg" aria-hidden="true" focusable="false"><g fill="none" stroke="#D3908A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11Z"/><circle cx="12" cy="10" r="2.5"/></g></svg>'
    };
    footer.querySelectorAll('.site-footer__linklist a').forEach(function (a) {
      var href = (a.getAttribute('href') || '').toLowerCase();
      var svg = null;
      if (href.indexOf('mailto:') === 0) svg = contactIcons.mail;
      else if (href.indexOf('wa.me') !== -1 || href.indexOf('tel:') === 0 || href.indexOf('whatsapp') !== -1) svg = contactIcons.phone;
      else if (a.querySelector('img[src*="maps"], img[src*="flag"], img[src*="location"]')) svg = contactIcons.pin;
      if (!svg) return;
      if (a.classList.contains('klistel-contact-link')) return; // idempotent
      // hide the original raster icon(s) on this link
      a.querySelectorAll('img').forEach(function (img) { img.style.display = 'none'; });
      a.classList.add('klistel-contact-link');
      a.insertAdjacentHTML('afterbegin', svg);
    });

    // ---- 2) SECURE CHECKOUT payment row + Made-in-India line ----
    if (!footer.querySelector('.klistel-footer-payments')) {
      // Anchor: the first live copyright paragraph ("\u00A9 2026 KLISTEL").
      var smallText = footer.querySelector('.footer__small-text');
  var payIcons = [
        { label: 'Visa', svg: '<svg viewBox="0 0 780 500" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="Visa"><g clip-path="url(#klvisa_clip0_6278_125833)"> <path d="M780 0H0V500H780V0Z" fill="#1434CB"/> <path d="M489.823 143.111C442.988 143.111 401.134 167.393 401.134 212.256C401.134 263.706 475.364 267.259 475.364 293.106C475.364 303.989 462.895 313.731 441.6 313.731C411.377 313.731 388.789 300.119 388.789 300.119L379.123 345.391C379.123 345.391 405.145 356.889 439.692 356.889C490.898 356.889 531.19 331.415 531.19 285.784C531.19 231.419 456.652 227.971 456.652 203.981C456.652 195.455 466.887 186.114 488.122 186.114C512.081 186.114 531.628 196.014 531.628 196.014L541.087 152.289C541.087 152.289 519.818 143.111 489.823 143.111ZM61.3294 146.411L60.1953 153.011C60.1953 153.011 79.8988 156.618 97.645 163.814C120.495 172.064 122.122 176.868 125.971 191.786L167.905 353.486H224.118L310.719 146.411H254.635L198.989 287.202L176.282 167.861C174.199 154.203 163.651 146.411 150.74 146.411H61.3294ZM333.271 146.411L289.275 353.486H342.756L386.598 146.411H333.271ZM631.554 146.411C618.658 146.411 611.825 153.318 606.811 165.386L528.458 353.486H584.542L595.393 322.136H663.72L670.318 353.486H719.805L676.633 146.411H631.554ZM638.848 202.356L655.473 280.061H610.935L638.848 202.356Z" fill="white"/> </g> <defs> <clipPath id="klvisa_clip0_6278_125833"> <rect width="780" height="500" fill="white"/> </clipPath> </defs></svg>' },
        { label: 'Mastercard', svg: '<svg viewBox="0 0 780 500" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="Mastercard"><g clip-path="url(#klmastercard_clip0_6278_125825)"> <path d="M780 0H0V500H780V0Z" fill="#253747"/> <path d="M211.053 467.045V438.109C211.053 427.041 204.311 419.793 192.736 419.793C186.949 419.793 180.657 421.703 176.33 427.996C172.959 422.715 168.127 419.793 160.879 419.793C156.047 419.793 151.215 421.254 147.395 426.535V420.748H137.281V467.045H147.395V441.481C147.395 433.278 151.721 429.401 158.463 429.401C165.205 429.401 168.577 433.727 168.577 441.481V467.045H178.69V441.481C178.69 433.278 183.522 429.401 189.759 429.401C196.501 429.401 199.872 433.727 199.872 441.481V467.045H211.053ZM361.068 420.748H344.662V406.758H334.549V420.748H325.391V429.906H334.549V451.145C334.549 461.764 338.875 468 350.449 468C354.776 468 359.608 466.539 362.979 464.629L360.057 455.92C357.135 457.831 353.764 458.336 351.348 458.336C346.516 458.336 344.606 455.415 344.606 450.639V429.906H361.012V420.748H361.068ZM446.92 419.737C441.133 419.737 437.256 422.658 434.84 426.479V420.692H424.727V466.989H434.84V440.919C434.84 433.221 438.211 428.839 444.504 428.839C446.414 428.839 448.83 429.345 450.797 429.794L453.718 420.13C451.696 419.737 448.83 419.737 446.92 419.737ZM317.187 424.569C312.356 421.198 305.613 419.737 298.365 419.737C286.791 419.737 279.094 425.524 279.094 434.682C279.094 442.38 284.881 446.762 294.994 448.167L299.826 448.672C305.108 449.628 308.029 451.088 308.029 453.504C308.029 456.875 304.152 459.291 297.41 459.291C290.668 459.291 285.33 456.875 281.959 454.459L277.127 462.157C282.409 466.034 289.657 467.944 296.904 467.944C310.389 467.944 318.143 461.651 318.143 452.999C318.143 444.796 311.85 440.469 302.242 439.008L297.41 438.503C293.084 437.997 289.713 437.042 289.713 434.176C289.713 430.805 293.084 428.895 298.421 428.895C304.209 428.895 309.996 431.311 312.917 432.772L317.187 424.569ZM586.26 419.737C580.473 419.737 576.596 422.658 574.18 426.479V420.692H564.067V466.989H574.18V440.919C574.18 433.221 577.551 428.839 583.844 428.839C585.754 428.839 588.17 429.345 590.137 429.794L593.059 420.242C591.092 419.737 588.227 419.737 586.26 419.737ZM457.033 443.897C457.033 457.887 466.697 468 481.643 468C488.385 468 493.217 466.539 498.049 462.719L493.217 454.516C489.34 457.437 485.519 458.842 481.137 458.842C472.934 458.842 467.147 453.055 467.147 443.897C467.147 435.188 472.934 429.401 481.137 428.951C485.463 428.951 489.34 430.412 493.217 433.278L498.049 425.074C493.217 421.198 488.385 419.793 481.643 419.793C466.697 419.737 457.033 429.906 457.033 443.897ZM550.582 443.897V420.748H540.469V426.535C537.098 422.209 532.266 419.793 525.973 419.793C512.938 419.793 502.825 429.906 502.825 443.897C502.825 457.887 512.938 468 525.973 468C532.715 468 537.547 465.584 540.469 461.258V467.045H550.582V443.897ZM513.444 443.897C513.444 435.693 518.725 428.951 527.434 428.951C535.637 428.951 541.424 435.244 541.424 443.897C541.424 452.1 535.637 458.842 527.434 458.842C518.781 458.336 513.444 452.043 513.444 443.897ZM392.42 419.737C378.935 419.737 369.271 429.401 369.271 443.84C369.271 458.336 378.935 467.944 392.926 467.944C399.668 467.944 406.41 466.034 411.748 461.651L406.916 454.403C403.039 457.325 398.207 459.235 393.431 459.235C387.139 459.235 380.902 456.314 379.441 448.167H413.658C413.658 446.706 413.658 445.751 413.658 444.29C414.108 429.401 405.399 419.737 392.42 419.737ZM392.42 428.446C398.713 428.446 403.039 432.322 403.994 439.514H379.891C380.846 433.278 385.172 428.446 392.42 428.446ZM643.682 443.897V402.432H633.568V426.535C630.197 422.209 625.365 419.793 619.073 419.793C606.037 419.793 595.924 429.906 595.924 443.897C595.924 457.887 606.037 468 619.073 468C625.815 468 630.647 465.584 633.568 461.258V467.045H643.682V443.897ZM606.543 443.897C606.543 435.693 611.825 428.951 620.533 428.951C628.736 428.951 634.524 435.244 634.524 443.897C634.524 452.1 628.736 458.842 620.533 458.842C611.825 458.336 606.543 452.043 606.543 443.897ZM267.969 443.897V420.748H257.855V426.535C254.484 422.209 249.652 419.793 243.36 419.793C230.325 419.793 220.211 429.906 220.211 443.897C220.211 457.887 230.325 468 243.36 468C250.102 468 254.934 465.584 257.855 461.258V467.045H267.969V443.897ZM230.381 443.897C230.381 435.693 235.662 428.951 244.371 428.951C252.574 428.951 258.361 435.244 258.361 443.897C258.361 452.1 252.574 458.842 244.371 458.842C235.662 458.336 230.381 452.043 230.381 443.897Z" fill="white"/> <path d="M465.738 69.1387H313.812V342.088H465.738V69.1387Z" fill="#FF5A00"/> <path d="M323.926 205.613C323.926 150.158 349.996 100.94 390 69.1387C360.559 45.9902 323.42 32 282.91 32C186.945 32 109.297 109.648 109.297 205.613C109.297 301.578 186.945 379.227 282.91 379.227C323.42 379.227 360.559 365.237 390 342.088C349.94 310.737 323.926 261.069 323.926 205.613Z" fill="#EB001B"/> <path d="M670.711 205.613C670.711 301.578 593.062 379.227 497.098 379.227C456.588 379.227 419.449 365.237 390.008 342.088C430.518 310.231 456.082 261.069 456.082 205.613C456.082 150.158 430.012 100.94 390.008 69.1387C419.393 45.9902 456.532 32 497.041 32C593.062 32 670.711 110.154 670.711 205.613Z" fill="#F79E1B"/> </g> <defs> <clipPath id="klmastercard_clip0_6278_125825"> <rect width="780" height="500" fill="white"/> </clipPath> </defs></svg>' },
        { label: 'RuPay', svg: '<svg viewBox="-131.2 196.4 600 157.6" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="RuPay"><path d="m435 208 33.8 67.2-71.1 67.3z" fill="#018c45"/><path d="m411.5 208 33.8 67.2-71.1 67.3z" fill="#f47920"/><path d="m-76.2 248.7h16.4c5.8 0 10-.8 12.6-2.5s4.6-4.6 5.7-8.8c1.2-4.3.9-7.2-.8-8.9s-5.8-2.5-12.2-2.5h-15.5zm-55 69.3 33.8-121.6h54c16.9 0 28.1 2.7 33.9 8.2 5.7 5.5 6.8 14.4 3.4 26.9-2.1 7.4-5.2 13.6-9.6 18.5-4.3 4.9-10 8.8-16.9 11.6 5.9 1.4 9.7 4.2 11.4 8.5 1.7 4.2 1.5 10.4-.6 18.5l-4.1 17v.5c-1.2 4.8-.8 7.3 1.1 7.5l-1.2 4.5h-36.5c.1-2.9.4-5.4.6-7.6.3-2.2.6-3.9.9-5.1l3.4-12.1c1.7-6.3 1.8-10.7.2-13.3s-5.2-3.9-10.9-3.9h-15.3l-11.9 41.9zm225.1-89.7-24.9 89.7h-30.2l3.7-13.1c-5.3 5.2-10.8 9.2-16.3 11.7-5.4 2.6-11.2 3.9-17.2 3.9-5 0-9.3-.9-12.7-2.7-3.5-1.8-6.1-4.5-7.9-8.1-1.6-3.1-2.2-7-2-11.7.3-4.6 1.9-12.3 4.9-23.1l12.9-46.6h33.1l-12.9 46.3c-1.9 6.8-2.3 11.6-1.4 14.1 1 2.6 3.5 4 7.6 4 4.2 0 7.7-1.5 10.6-4.6s5.2-7.6 6.9-13.7l12.8-46.2h33zm42.7 22.8h11.7c7.5 0 12.8-.9 15.9-2.7 3-1.8 5.1-5.1 6.4-9.7 1.3-4.7 1-7.9-1-9.7-1.9-1.8-6.7-2.7-14.5-2.7h-11.6zm-54.7 66.9 33.7-121.6h46.4c10.2 0 18.2.6 23.8 1.9s10.1 3.3 13.3 6.2c4.1 3.8 6.6 8.5 7.7 14.2 1 5.6.4 12.2-1.7 20-3.8 13.6-10.4 24-19.8 31.3-9.5 7.2-21.2 10.8-35.1 10.8h-21.7l-10.4 37.2zm170.1-40.1c-3.5 1.4-8.1 2.8-13.7 4.2-8.9 2.4-13.9 5.6-15 9.5-.8 2.5-.4 4.5.8 6 1.2 1.4 3.3 2.1 6.3 2.1 5.5 0 9.9-1.4 13.2-4.1 3.3-2.8 5.8-7.1 7.5-13.1.3-1.3.6-2.2.7-2.9zm-8 40.1.3-8.5c-5.3 4-10.7 7-16.2 8.9-5.4 1.9-11.2 2.9-17.3 2.9-9.4 0-15.9-2.5-19.7-7.5-3.7-4.9-4.3-12-1.8-21.1 2.4-8.9 6.8-15.5 13-19.7s16.6-7.3 31.2-9.2c1.8-.3 4.3-.5 7.4-.9 10.8-1.2 16.8-4.1 18.1-8.8.7-2.6.3-4.5-1.3-5.6-1.5-1.2-4.4-1.8-8.5-1.8-3.4 0-6.2.7-8.5 2.2s-4 3.7-5.1 6.8h-32.2c2.9-10.1 8.9-17.7 17.8-22.8 8.9-5.2 20.6-7.7 35.2-7.7 6.8 0 13 .6 18.4 2 5.4 1.3 9.4 3.2 11.9 5.5 3.2 2.9 5 6.1 5.6 9.7s-.1 8.8-1.9 15.5l-13.9 50c-.4 1.6-.5 3.1-.3 4.4.3 1.3.8 2.4 1.8 3.1l-.7 2.5h-33.3zm33.5 35.4 7.3-26.6h9.5c3.2 0 5.6-.6 7.4-1.8s3-3.2 3.7-5.9c.4-1.2.6-2.4.7-3.8.1-1.5.1-3.1 0-4.9l-5.1-82.2h33.5l-.5 54.4 29.2-54.4h31.1l-51.7 89.3c-5.9 10-10.1 16.8-12.8 20.6-2.7 3.7-5.2 6.6-7.7 8.5-3.2 2.7-6.7 4.6-10.6 5.7s-9.7 1.7-17.6 1.7c-2.3 0-4.9 0-7.7-.2-2.7 0-5.7-.2-8.7-.4" fill="#29387e"/></svg>' },
        { label: 'UPI', svg: '<svg viewBox="0 0 130.54 46.118" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="UPI"><defs id="klupi_defs341"> <clipPath id="klupi_clipPath28" clipPathUnits="userSpaceOnUse"> <path id="klupi_path26" d="M 0,216 H 432 V 0 H 0 Z" /> </clipPath> </defs> <g id="klupi_layer1" > <g id="klupi_g22" transform="matrix(0.35277777,0,0,-0.35277777,-10.926321,61.158633)"> <g id="klupi_g24" clip-path="url(#klupi_clipPath28)"> <g id="klupi_g30" transform="translate(33.9766,61.0674)"> <path d="M 0,0 H 2.77 L 0.196,-10.751 c -0.382,-1.595 -0.31,-2.796 0.218,-3.597 0.526,-0.802 1.505,-1.203 2.936,-1.203 1.422,0 2.588,0.401 3.499,1.203 0.912,0.801 1.559,2.002 1.941,3.597 L 11.363,0 h 2.806 l -2.637,-11.017 c -0.573,-2.394 -1.594,-4.186 -3.056,-5.374 -1.463,-1.19 -3.381,-1.784 -5.754,-1.784 -2.375,0 -4.004,0.593 -4.891,1.778 -0.888,1.184 -1.043,2.978 -0.468,5.38 z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path32" /> </g> <g id="klupi_g34" transform="translate(47.7734,43.3633)"> <path d="M 0,0 4.406,18.405 12.778,7.582 C 13.002,7.277 13.228,6.95 13.451,6.603 13.674,6.256 13.902,5.866 14.136,5.43 l 2.939,12.274 h 2.593 L 15.265,-0.687 6.717,10.329 C 6.488,10.626 6.275,10.94 6.076,11.271 5.875,11.602 5.694,11.949 5.528,12.311 L 2.581,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path36" /> </g> <g id="klupi_g38" transform="translate(67.2119,43.3633)"> <path d="M 0,0 4.238,17.704 H 7.042 L 2.805,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path40" /> </g> <g id="klupi_g42" transform="translate(74.0488,43.3633)"> <path d="m 0,0 4.238,17.704 h 9.63 L 13.283,15.262 H 6.458 L 5.401,10.848 h 6.825 L 11.622,8.321 H 4.796 L 2.805,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path44" /> </g> <g id="klupi_g46" transform="translate(86.7686,43.3633)"> <path d="M 0,0 4.238,17.704 H 7.042 L 2.805,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path48" /> </g> <g id="klupi_g50" transform="translate(93.6055,43.3633)"> <path d="m 0,0 4.238,17.704 h 9.63 L 13.283,15.262 H 6.458 L 5.395,10.824 H 12.22 L 11.616,8.296 H 4.791 l -1.37,-5.72 h 6.825 L 9.63,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path52" /> </g> <g id="klupi_g54" transform="translate(109.8818,45.9639)"> <path d="m 0,0 h 2.358 c 1.296,0 2.29,0.089 2.981,0.266 0.691,0.177 1.325,0.476 1.906,0.895 0.789,0.571 1.448,1.283 1.978,2.134 0.529,0.85 0.93,1.841 1.2,2.97 0.269,1.129 0.343,2.117 0.221,2.966 -0.123,0.852 -0.441,1.563 -0.956,2.136 -0.387,0.418 -0.898,0.718 -1.536,0.896 -0.639,0.176 -1.679,0.265 -3.125,0.265 H 4.013 2.999 Z m -3.427,-2.601 4.238,17.705 h 3.783 c 2.46,0 4.16,-0.126 5.102,-0.38 0.94,-0.255 1.717,-0.681 2.328,-1.277 0.811,-0.782 1.327,-1.786 1.549,-3.01 C 13.794,9.211 13.716,7.812 13.34,6.24 12.964,4.668 12.373,3.275 11.567,2.062 10.763,0.848 9.766,-0.153 8.58,-0.943 7.683,-1.54 6.721,-1.965 5.699,-2.22 4.674,-2.473 3.146,-2.601 1.11,-2.601 H 0.355 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path56" /> </g> <g id="klupi_g58" transform="translate(136.8799,53.666)"> <path d="M 0,0 H 0.72 C 2.275,0 3.354,0.175 3.956,0.521 4.559,0.867 4.964,1.48 5.174,2.359 5.4,3.302 5.283,3.968 4.821,4.354 4.359,4.741 3.387,4.936 1.902,4.936 h -0.72 z m -0.741,-2.356 -1.902,-7.947 H -5.271 L -1.032,7.401 H 3.211 C 4.468,7.401 5.377,7.331 5.937,7.19 6.495,7.05 6.956,6.817 7.32,6.494 7.763,6.083 8.054,5.529 8.194,4.832 8.333,4.134 8.303,3.366 8.103,2.529 7.901,1.69 7.563,0.916 7.087,0.206 6.611,-0.503 6.053,-1.06 5.415,-1.462 4.897,-1.785 4.326,-2.015 3.7,-2.151 3.073,-2.289 2.132,-2.356 0.875,-2.356 H 0.322 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path60" /> </g> <g id="klupi_g62" transform="translate(148.4458,50.3164)"> <path d="M 0,0 H 4.809 L 4.006,4.04 C 3.968,4.297 3.932,4.593 3.901,4.928 3.872,5.263 3.852,5.636 3.839,6.047 3.653,5.66 3.466,5.299 3.279,4.964 3.093,4.63 2.912,4.322 2.734,4.04 Z M 6.092,-6.953 5.225,-2.394 H -1.612 L -4.707,-6.953 H -7.652 L 5.109,11.452 9.05,-6.953 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path64" /> </g> <g id="klupi_g66" transform="translate(161.5161,43.3633)"> <path d="m 0,0 1.938,8.103 -3.512,9.601 h 2.947 l 2.18,-6.01 c 0.05,-0.154 0.11,-0.355 0.179,-0.605 0.07,-0.25 0.138,-0.519 0.202,-0.81 0.176,0.282 0.357,0.55 0.538,0.799 0.181,0.25 0.364,0.479 0.549,0.689 l 5.133,5.937 H 12.96 L 4.72,8.103 2.781,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path68" /> </g> <g id="klupi_g70" transform="translate(188.2803,52.1074)"> <path d="M 0,0 C 0.001,0.137 0.041,0.515 0.119,1.136 0.179,1.652 0.226,2.08 0.26,2.419 0.093,2.015 -0.104,1.611 -0.33,1.209 -0.557,0.806 -0.817,0.395 -1.114,-0.025 l -6.773,-9.433 -2.21,9.626 c -0.094,0.396 -0.166,0.779 -0.214,1.149 -0.048,0.371 -0.081,0.738 -0.097,1.102 -0.096,-0.372 -0.218,-0.76 -0.367,-1.168 -0.149,-0.407 -0.327,-0.833 -0.536,-1.276 l -3.938,-8.719 h -2.58 l 8.495,18.455 2.418,-11.175 c 0.035,-0.177 0.086,-0.472 0.148,-0.883 0.062,-0.411 0.135,-0.919 0.22,-1.523 0.286,0.508 0.698,1.152 1.24,1.934 0.144,0.21 0.254,0.371 0.328,0.484 L 2.667,9.711 2.422,-8.744 h -2.606 z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path72" /> </g> <g id="klupi_g74" transform="translate(192.9419,43.3633)"> <path d="m 0,0 4.239,17.704 h 9.63 L 13.284,15.262 H 6.458 L 5.396,10.824 h 6.825 L 11.617,8.296 H 4.791 L 3.422,2.576 h 6.825 L 9.629,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path76" /> </g> <g id="klupi_g78" transform="translate(205.791,43.3633)"> <path d="M 0,0 4.406,18.405 12.778,7.582 C 13.002,7.277 13.228,6.95 13.451,6.603 13.674,6.256 13.902,5.866 14.136,5.43 l 2.939,12.274 h 2.594 L 15.265,-0.687 6.717,10.329 C 6.488,10.626 6.275,10.94 6.076,11.271 5.875,11.602 5.694,11.949 5.528,12.311 L 2.581,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path80" /> </g> <g id="klupi_g82" transform="translate(234.4102,58.625)"> <path d="M 0,0 -3.653,-15.262 H -6.458 L -2.806,0 h -4.585 l 0.585,2.442 H 5.146 L 4.562,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path84" /> </g> <g id="klupi_g86" transform="translate(237.3213,46.9072)"> <path d="M 0,0 2.494,1.063 C 2.519,0.274 2.763,-0.329 3.229,-0.744 3.695,-1.16 4.368,-1.367 5.25,-1.367 c 0.832,0 1.552,0.238 2.156,0.714 0.605,0.475 1.004,1.112 1.195,1.91 C 8.85,2.298 8.229,3.225 6.744,4.038 6.536,4.159 6.376,4.248 6.266,4.305 4.591,5.256 3.529,6.117 3.081,6.887 2.634,7.657 2.542,8.598 2.808,9.71 c 0.345,1.443 1.103,2.612 2.272,3.507 1.169,0.895 2.527,1.343 4.076,1.343 1.273,0 2.278,-0.252 3.013,-0.756 0.736,-0.505 1.156,-1.228 1.26,-2.171 L 10.96,10.472 c -0.214,0.556 -0.496,0.963 -0.846,1.222 -0.351,0.258 -0.795,0.387 -1.328,0.387 -0.754,0 -1.402,-0.203 -1.943,-0.604 C 6.305,11.073 5.952,10.533 5.789,9.855 5.535,8.791 6.272,7.8 8.001,6.881 8.134,6.809 8.238,6.751 8.313,6.711 9.826,5.906 10.81,5.117 11.261,4.347 11.713,3.576 11.802,2.615 11.525,1.463 11.124,-0.215 10.291,-1.547 9.025,-2.534 7.759,-3.521 6.249,-4.015 4.498,-4.015 c -1.471,0 -2.592,0.346 -3.364,1.04 C 0.36,-2.282 -0.018,-1.291 0,0" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path88" /> </g> <g id="klupi_g90" transform="translate(258.0459,43.3633)"> <path d="M 0,0 4.238,17.704 H 7.043 L 2.805,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path92" /> </g> <g id="klupi_g94" transform="translate(264.8828,43.3633)"> <path d="M 0,0 4.406,18.405 12.778,7.582 C 13.002,7.277 13.228,6.95 13.451,6.603 13.674,6.256 13.902,5.866 14.136,5.43 l 2.939,12.274 h 2.593 L 15.265,-0.687 6.717,10.329 c -0.229,0.297 -0.443,0.611 -0.642,0.942 -0.2,0.331 -0.382,0.678 -0.548,1.04 L 2.581,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path96" /> </g> <g id="klupi_g98" transform="translate(293.502,58.625)"> <path d="M 0,0 -3.654,-15.262 H -6.458 L -2.806,0 h -4.585 l 0.585,2.442 H 5.146 L 4.562,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path100" /> </g> <g id="klupi_g102" transform="translate(296.5557,43.3633)"> <path d="m 0,0 4.238,17.704 h 9.63 L 13.284,15.262 H 6.459 L 5.396,10.824 h 6.825 L 11.616,8.296 H 4.791 L 3.422,2.576 h 6.825 L 9.63,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path104" /> </g> <g id="klupi_g106" transform="translate(314.6416,53.5225)"> <path d="M 0,0 H 0.508 C 1.992,0 3.021,0.176 3.593,0.531 4.165,0.886 4.561,1.514 4.775,2.418 5.009,3.393 4.913,4.081 4.484,4.479 4.059,4.88 3.138,5.079 1.724,5.079 H 1.216 Z m -0.712,-2.237 -1.897,-7.922 h -2.628 l 4.239,17.704 h 3.913 c 1.147,0 2.019,-0.076 2.614,-0.23 C 6.125,7.162 6.605,6.909 6.968,6.553 7.4,6.127 7.68,5.573 7.81,4.896 7.937,4.22 7.904,3.478 7.712,2.673 7.373,1.254 6.773,0.143 5.913,-0.66 5.053,-1.461 3.951,-1.944 2.608,-2.104 l 4.014,-8.055 H 3.45 l -3.844,7.922 z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path108" /> </g> <g id="klupi_g110" transform="translate(322.9258,43.3633)"> <path d="m 0,0 4.238,17.704 h 9.63 L 13.284,15.262 H 6.458 L 5.401,10.848 h 6.826 L 11.622,8.321 H 4.797 L 2.805,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path112" /> </g> <g id="klupi_g114" transform="translate(340.0449,50.3164)"> <path d="M 0,0 H 4.81 L 4.007,4.04 C 3.968,4.297 3.933,4.593 3.902,4.928 3.873,5.263 3.853,5.636 3.84,6.047 3.653,5.66 3.466,5.299 3.28,4.964 3.094,4.63 2.912,4.322 2.734,4.04 Z M 6.093,-6.953 5.226,-2.394 H -1.611 L -4.706,-6.953 H -7.652 L 5.109,11.452 9.051,-6.953 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path116" /> </g> <g id="klupi_g118" transform="translate(367.3555,56.7627)"> <path d="m 0,0 c -0.627,0.693 -1.341,1.213 -2.143,1.56 -0.8,0.345 -1.688,0.52 -2.663,0.52 -1.885,0 -3.569,-0.621 -5.048,-1.862 -1.481,-1.242 -2.457,-2.85 -2.93,-4.826 -0.457,-1.911 -0.258,-3.486 0.596,-4.727 0.854,-1.242 2.158,-1.864 3.909,-1.864 1.023,0 2.039,0.186 3.051,0.557 1.012,0.371 2.033,0.931 3.06,1.682 l -0.779,-3.254 c -0.887,-0.556 -1.808,-0.972 -2.761,-1.245 -0.954,-0.274 -1.949,-0.411 -2.986,-0.411 -1.32,0 -2.488,0.221 -3.501,0.665 -1.014,0.443 -1.843,1.095 -2.484,1.959 -0.638,0.846 -1.047,1.843 -1.222,2.993 -0.178,1.148 -0.111,2.372 0.199,3.671 0.311,1.297 0.83,2.516 1.555,3.657 0.724,1.141 1.619,2.143 2.681,3.005 1.066,0.871 2.206,1.529 3.42,1.978 1.215,0.446 2.468,0.671 3.757,0.671 1.014,0 1.944,-0.152 2.791,-0.455 C -0.651,3.973 0.131,3.516 0.85,2.901 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path120" /> </g> <g id="klupi_g122" transform="translate(367.627,43.3633)"> <path d="m 0,0 4.238,17.704 h 9.63 L 13.283,15.262 H 6.459 L 5.396,10.824 h 6.825 L 11.616,8.296 H 4.791 L 3.422,2.576 h 6.825 L 9.63,0 Z" style="fill:#696a6a;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path124" /> </g> <g id="klupi_g126" transform="translate(316.4629,76.4951)"> <path d="M 0,0 H -19.283 L 7.535,96.855 h 19.284 z" style="fill:#66686c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path128" /> </g> <g id="klupi_g130" transform="translate(306.4521,170.2881)"> <path d="m 0,0 c -1.337,1.843 -3.399,2.773 -6.2,2.773 h -106.036 l -5.252,-18.97 h 19.294 v 0.011 h 77.169 l -5.614,-20.272 h -77.171 l 0.007,0.042 h -19.286 l -16.007,-57.787 h 19.296 l 10.742,38.786 h 86.746 c 2.709,0 5.259,0.924 7.657,2.772 2.393,1.85 3.968,4.131 4.723,6.855 L 0.809,-6.996 C 1.593,-4.181 1.322,-1.845 0,0" style="fill:#66686c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path132" /> </g> <g id="klupi_g134" transform="translate(156.1196,82.541)"> <path d="m 0,0 c -1.065,-3.835 -4.557,-6.488 -8.538,-6.488 h -99.491 c -2.711,0 -4.726,0.924 -6.051,2.77 -1.324,1.848 -1.608,4.134 -0.851,6.857 l 24.276,87.387 h 19.301 l -21.683,-78.05 h 77.206 l 21.683,78.05 h 19.297 z" style="fill:#66686c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path136" /> </g> <g id="klupi_g138" transform="translate(376.5859,173.1689)"> <path d="m 0,0 24.414,-48.553 -51.322,-48.54 z" style="fill:#27803b;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path140" /> </g> <g id="klupi_g142" transform="translate(359.4717,173.1689)"> <path d="m 0,0 24.396,-48.553 -51.343,-48.54 z" style="fill:#e9661c;fill-opacity:1;fill-rule:nonzero;stroke:none" id="klupi_path144" /> </g> </g> </g> </g></svg>' },
        { label: 'Razorpay', svg: '<svg viewBox=".8 .48 1894.74 400.27" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="Razorpay"><path d="m122.63 105.7-15.75 57.97 90.15-58.3-58.96 219.98 59.88.05 87.1-324.92" fill="#3395ff"/><path d="m25.6 232.92-24.8 92.48h122.73l50.22-188.13zm426.32-81.42c-3 11.15-8.78 19.34-17.4 24.57-8.6 5.22-20.67 7.84-36.25 7.84h-49.5l17.38-64.8h49.5c15.56 0 26.25 2.6 32.05 7.9s7.2 13.4 4.22 24.6m51.25-1.4c6.3-23.4 3.7-41.4-7.82-54-11.5-12.5-31.68-18.8-60.48-18.8h-110.47l-66.5 248.1h53.67l26.8-100h35.2c7.9 0 14.12 1.3 18.66 3.8 4.55 2.6 7.22 7.1 8.04 13.6l9.58 82.6h57.5l-9.32-77c-1.9-17.2-9.77-27.3-23.6-30.3 17.63-5.1 32.4-13.6 44.3-25.4a92.6 92.6 0 0 0 24.44-42.5m130.46 86.4c-4.5 16.8-11.4 29.5-20.73 38.4-9.34 8.9-20.5 13.3-33.52 13.3-13.26 0-22.25-4.3-27-13-4.76-8.7-4.92-21.3-.5-37.8s11.47-29.4 21.17-38.7 21.04-13.95 34.06-13.95c13 0 21.9 4.5 26.4 13.43 4.6 8.97 4.7 21.8.2 38.5zm23.52-87.8-6.72 25.1c-2.9-9-8.53-16.2-16.85-21.6-8.34-5.3-18.66-8-30.97-8-15.1 0-29.6 3.9-43.5 11.7s-26.1 18.8-36.5 33-18 30.3-22.9 48.4c-4.8 18.2-5.8 34.1-2.9 47.9 3 13.9 9.3 24.5 19 31.9 9.8 7.5 22.3 11.2 37.6 11.2a82.4 82.4 0 0 0 35.2-7.7 82.11 82.11 0 0 0 28.4-21.2l-7 26.16h51.9l47.39-176.77h-52zm238.65 0h-150.93l-10.55 39.4h87.82l-116.1 100.3-9.92 37h155.8l10.55-39.4h-94.1l117.88-101.8m142.4 52c-4.67 17.4-11.6 30.48-20.75 39-9.15 8.6-20.23 12.9-33.24 12.9-27.2 0-36.14-17.3-26.86-51.9 4.6-17.2 11.56-30.13 20.86-38.84 9.3-8.74 20.57-13.1 33.82-13.1 13 0 21.78 4.33 26.3 13.05 4.52 8.7 4.48 21.67-.13 38.87m30.38-80.83c-11.95-7.44-27.2-11.16-45.8-11.16-18.83 0-36.26 3.7-52.3 11.1a113.09 113.09 0 0 0 -41 32.06c-11.3 13.9-19.43 30.2-24.42 48.8-4.9 18.53-5.5 34.8-1.7 48.73 3.8 13.9 11.8 24.6 23.8 32 12.1 7.46 27.5 11.17 46.4 11.17 18.6 0 35.9-3.74 51.8-11.18 15.9-7.48 29.5-18.1 40.8-32.1 11.3-13.94 19.4-30.2 24.4-48.8s5.6-34.84 1.8-48.8c-3.8-13.9-11.7-24.6-23.6-32.05m185.1 40.8 13.3-48.1c-4.5-2.3-10.4-3.5-17.8-3.5-11.9 0-23.3 2.94-34.3 8.9-9.46 5.06-17.5 12.2-24.3 21.14l6.9-25.9-15.07.06h-37l-47.7 176.7h52.63l24.75-92.37c3.6-13.43 10.08-24 19.43-31.5 9.3-7.53 20.9-11.3 34.9-11.3 8.6 0 16.6 1.97 24.2 5.9m146.5 41.1c-4.5 16.5-11.3 29.1-20.6 37.8-9.3 8.74-20.5 13.1-33.5 13.1s-21.9-4.4-26.6-13.2c-4.8-8.85-4.9-21.6-.4-38.36 4.5-16.75 11.4-29.6 20.9-38.5 9.5-8.97 20.7-13.45 33.7-13.45 12.8 0 21.4 4.6 26 13.9s4.7 22.2.28 38.7m36.8-81.4c-9.75-7.8-22.2-11.7-37.3-11.7-13.23 0-25.84 3-37.8 9.06-11.95 6.05-21.65 14.3-29.1 24.74l.18-1.2 8.83-28.1h-51.4l-13.1 48.9-.4 1.7-54 201.44h52.7l27.2-101.4c2.7 9.02 8.2 16.1 16.6 21.22 8.4 5.1 18.77 7.63 31.1 7.63 15.3 0 29.9-3.7 43.75-11.1 13.9-7.42 25.9-18.1 36.1-31.9s17.77-29.8 22.6-47.9c4.9-18.13 5.9-34.3 3.1-48.45-2.85-14.17-9.16-25.14-18.9-32.9m174.65 80.65c-4.5 16.7-11.4 29.5-20.7 38.3-9.3 8.86-20.5 13.27-33.5 13.27-13.3 0-22.3-4.3-27-13-4.8-8.7-4.9-21.3-.5-37.8s11.42-29.4 21.12-38.7 21.05-13.94 34.07-13.94c13 0 21.8 4.5 26.4 13.4 4.6 8.93 4.63 21.76.15 38.5zm23.5-87.85-6.73 25.1c-2.9-9.05-8.5-16.25-16.8-21.6-8.4-5.34-18.7-8-31-8-15.1 0-29.68 3.9-43.6 11.7-13.9 7.8-26.1 18.74-36.5 32.9s-18 30.3-22.9 48.4c-4.85 18.17-5.8 34.1-2.9 47.96 2.93 13.8 9.24 24.46 19 31.9 9.74 7.4 22.3 11.14 37.6 11.14 12.3 0 24.05-2.56 35.2-7.7a82.3 82.3 0 0 0 28.33-21.23l-7 26.18h51.9l47.38-176.7h-51.9zm269.87.06.03-.05h-31.9c-1.02 0-1.92.05-2.85.07h-16.55l-8.5 11.8-2.1 2.8-.9 1.4-67.25 93.68-13.9-109.7h-55.08l27.9 166.7-61.6 85.3h54.9l14.9-21.13c.42-.62.8-1.14 1.3-1.8l17.4-24.7.5-.7 77.93-110.5 65.7-93 .1-.06h-.03z"/></svg>' },
        { label: 'Cash on Delivery', svg: '<svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" class="klistel-pay-svg" role="img" aria-label="Cash on Delivery"><g fill="none" stroke="#2C2C2C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9.5v.01M18 14.5v.01"/></g></svg>' },
      ];
      var chipHtml = payIcons.map(function (p) {
        return '<span class="klistel-pay-chip" title="' + p.label + '">' + p.svg + '</span>';
      }).join('');

      var pay = document.createElement('div');
      pay.className = 'klistel-footer-payments';
      pay.setAttribute('aria-label', 'Accepted payment methods');
      pay.innerHTML =
        '<div class="klistel-footer-payments-label">Secure Checkout</div>' +
        chipHtml;

      var madein = document.createElement('p');
      madein.className = 'klistel-footer-madein';
      madein.textContent = 'Made in India \u00B7 Handcrafted by Artisans';

      if (smallText && smallText.parentNode) {
        smallText.parentNode.insertBefore(pay, smallText);
        // place the italic "Made in India" line right after the last
        // copyright paragraph so it reads as the closing line.
        var smalls = footer.querySelectorAll('.footer__small-text');
        var last = smalls[smalls.length - 1];
        if (last && last.parentNode) {
          last.parentNode.insertBefore(madein, last.nextSibling);
        } else {
          pay.parentNode.insertBefore(madein, pay.nextSibling);
        }
      } else {
        pageWidth.appendChild(pay);
        pageWidth.appendChild(madein);
      }
    }
  }

  // Collapse the PDP product-tab accordions on load so they start closed
  // (V1 spec: "collapsed by default"). Impulse renders them OPEN by default
  // (icon --open + content --all). We mirror Impulse's own "closed" state:
  // remove the open classes AND set an explicit inline height: 0px on the
  // content. The CSS only clips overflow (no !important), so this inline 0
  // is what hides the body. Impulse's native click handler then overwrites
  // this inline height when the user opens/closes the panel afterwards.
  function collapseTabsOnce() {
    // v7.1 â€” Always check for an orphan description block first. On some
    // PDPs Impulse renders the description OUTSIDE the tab structure as a
    // plain .product-block > .rte, while still rendering other tabs (FABRIC,
    // COLOR, etc.) inside .product-block--tab. We need both: wrap the orphan
    // into a Description chevron AND collapse the native tabs as before.
    wrapOrphanDescription();

    if (window.__klistelTabsCollapsed) return; // once per load
    var tabs = document.querySelectorAll(
      '.product-block--tab .collapsible-trigger-btn--borders'
    );
    if (!tabs.length) return;
    window.__klistelTabsCollapsed = true;

    tabs.forEach(function (btn) {
      var icon = btn.querySelector('.collapsible-trigger__icon');
      if (icon) icon.classList.remove('collapsible-trigger__icon--open');
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');

      var id = btn.getAttribute('aria-controls');
      var content = id ? document.getElementById(id) : null;
      if (content) {
        content.classList.remove('collapsible-content--all');
        content.style.height = '0px';    // initial closed state; Impulse
                                         // overwrites this on click to open
        content.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // v7 â€” Fallback for PDPs whose template renders the product description
  // as a flat .rte block instead of inside Impulse's collapsible tab section.
  // We build a matching chevron accordion that visually equals the native
  // .product-block--tab so every PDP uses the same Description chevron.
  function wrapOrphanDescription() {
    if (document.querySelector('.klistel-fallback-tab')) return; // once
    // v7.1 â€” Real DOM on broken PDPs (e.g. Noor):
    //   <div class="product-block">          <-- NO --tab modifier
    //     <div class="rte">â€¦descriptionâ€¦</div>
    //   </div>
    // Match ANY .product-block that is NOT a recognized variant block AND
    // contains a direct .rte child. We look for product-block elements
    // anywhere in .product-single__meta (the right column).
    var raw = null;
    var blocks = document.querySelectorAll('.product-single__meta .product-block');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      // Skip the known variant/specialized blocks.
      if (b.classList.contains('product-block--tab')) continue;
      if (b.classList.contains('product-block--header')) continue;
      if (b.classList.contains('product-block--price')) continue;
      if (b.classList.contains('product-block--variants')) continue;
      if (b.classList.contains('product-block--buy-buttons')) continue;
      // Skip product-block--description: already wrapped/styled.
      if (b.classList.contains('product-block--description')) continue;
      // Must have a direct .rte child with actual content.
      var rte = b.querySelector(':scope > .rte');
      if (!rte) continue;
      var txt = (rte.textContent || '').trim();
      if (!txt) continue;
      raw = b; // wrap the whole product-block, not just .rte, so we preserve
               // any spacing classes the theme applies to this container.
      break;
    }
    if (!raw) return;
    // Don't double-wrap if already inside a collapsible.
    if (raw.closest('.product-block--tab') || raw.closest('.klistel-fallback-tab')) return;

    // Build the chevron-accordion wrapper.
    var tab = document.createElement('div');
    tab.className = 'product-block product-block--tab klistel-fallback-tab';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className =
      'collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'klistel-desc-panel');
    btn.innerHTML =
      '<span class="collapsible-trigger__layout">' +
        '<span class="collapsible-trigger__heading">DESCRIPTION</span>' +
        '<span class="collapsible-trigger__icon-wrapper">' +
          '<svg class="collapsible-trigger__icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
        '</span>' +
      '</span>';

    var panel = document.createElement('div');
    panel.id = 'klistel-desc-panel';
    panel.className = 'collapsible-content';
    panel.setAttribute('aria-hidden', 'true');
    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
    panel.style.transition = 'height .25s ease';

    var inner = document.createElement('div');
    inner.className = 'collapsible-content__inner rte';
    // v7.1 â€” `raw` is the wrapper .product-block. Move ONLY its inner .rte
    // contents into the new collapsible inner panel.
    var srcRte = raw.querySelector(':scope > .rte');
    if (srcRte) {
      while (srcRte.firstChild) inner.appendChild(srcRte.firstChild);
    } else {
      while (raw.firstChild) inner.appendChild(raw.firstChild);
    }
    panel.appendChild(inner);

    tab.appendChild(btn);
    tab.appendChild(panel);
    // Replace the raw block in place to keep DOM order intact.
    raw.parentNode.replaceChild(tab, raw);

    // Toggle behaviour mirrors Impulse's own collapsible.
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        // next frame: animate to 0
        requestAnimationFrame(function () { panel.style.height = '0px'; });
        panel.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        panel.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        // After the transition, drop the inline height so it can grow if
        // content reflows.
        setTimeout(function () {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.height = 'auto';
          }
        }, 280);
      }
    });

    window.__klistelTabsCollapsed = true;
  }

  // Inject the secondary "WANT A TAILOR-MADE FIT?" button after the CTA row.
  function setupTailorCta() {
    if (document.querySelector('.klistel-tailor-trigger')) return; // once
    var row = document.querySelector('.klistel-cta-row');
    if (!row) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'klistel-tailor-trigger';
    btn.innerHTML =
      '<span class="klistel-tailor-icon" aria-hidden="true">' +
        // scissors icon
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><line x1="20" y1="4" x2="8.12" y2="15.88"/><line x1="14.47" y1="14.48" x2="20" y2="20"/><line x1="8.12" y1="8.12" x2="12" y2="12"/></svg>' +
      '</span>' +
      '<span class="klistel-tailor-label">Want a Tailor-Made Fit?</span>';
    // Place directly after the primary CTA row.
    row.insertAdjacentElement('afterend', btn);

    var sheet = buildTailorSheet();
    btn.addEventListener('click', function () {
      if (sheet && typeof sheet.klistelOpen === 'function') sheet.klistelOpen();
    });
  }

  // ===== STICKY BOTTOM ADD-TO-CART BAR (V1) =====
  // A fixed bar pinned to the bottom of the viewport: price + size on the left,
  // a square wishlist heart + ADD TO CART button on the right. Behaviour (per
  // Vivek): the bar is ALWAYS shown while scrolling, and only hides when the
  // real ADD TO CART (our .klistel-cta-row) is actually visible on screen.
  // The ADD TO CART here is WIRED to the real cart: it clicks the live
  // button[name="add"] so Impulse adds the currently selected size variant and
  // opens its cart drawer — no duplicate cart logic. The heart mirrors the main
  // heart (visual-only until the wishlist app is installed in the final phase).
  function setupStickyBar() {
    if (document.querySelector('.klistel-sticky-bar')) return; // once
    // The real ADD TO CART button + the row we observe for visibility.
    var realBtn = document.querySelector('button[name="add"], .btn.add-to-cart');
    var ctaRow = document.querySelector('.klistel-cta-row') ||
      (realBtn ? realBtn.closest('.klistel-cta-row') : null) || realBtn;
    if (!realBtn || !ctaRow) return;

    var bar = document.createElement('div');
    bar.className = 'klistel-sticky-bar';
    bar.innerHTML =
      '<div class="klistel-sticky-info">' +
        '<div class="klistel-sticky-price"></div>' +
        '<div class="klistel-sticky-size">Select size</div>' +
      '</div>' +
      '<div class="klistel-sticky-actions">' +
        '<button type="button" class="klistel-sticky-like" aria-label="Add to wishlist">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>' +
        '</button>' +
        '<button type="button" class="klistel-sticky-btn">Add to Cart</button>' +
      '</div>';
    document.body.appendChild(bar);

    var priceEl = bar.querySelector('.klistel-sticky-price');
    var sizeEl = bar.querySelector('.klistel-sticky-size');
    var likeBtn = bar.querySelector('.klistel-sticky-like');
    var addBtn = bar.querySelector('.klistel-sticky-btn');

    // Mirror the live product price (the on-sale/current price element).
    function syncPrice() {
      var src = document.querySelector('[data-product-price]:not(.product__price--compare)') ||
        document.querySelector('[data-product-price]');
      if (src) priceEl.textContent = src.textContent.trim();
    }
    // Mirror the currently selected size into the bar.
    function syncSize() {
      var label = (typeof getSelectedSizeLabel === 'function') ? getSelectedSizeLabel() : '';
      sizeEl.textContent = label ? ('Size: ' + label) : 'Select size';
    }
    syncPrice();
    syncSize();
    // Re-sync when the shopper changes size (radios) or Impulse updates price.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.variant-input input, select[name="id"]')) {
        syncSize();
        setTimeout(syncPrice, 50); // price updates a tick after variant change
      }
    });

    // Heart: mirror the main heart's visual-only toggle.
    likeBtn.addEventListener('click', function () {
      likeBtn.classList.toggle('liked');
      var mainHeart = document.querySelector('.klistel-wishlist-btn');
      if (mainHeart) mainHeart.classList.toggle('is-active', likeBtn.classList.contains('liked'));
    });

    // ADD TO CART: trigger the real button so Impulse handles add + drawer.
    addBtn.addEventListener('click', function () {
      realBtn.click();
    });

    // Visibility: show the bar whenever the real CTA row is OFF screen, hide it
    // when the CTA row is visible. IntersectionObserver = no scroll jank.
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting;
          bar.classList.toggle('is-visible', show);
          // Mirror onto <body> so the WhatsApp FAB can lift above the bar.
          document.body.classList.toggle('klistel-sticky-on', show);
          liftWhatsAppFab(show);
        });
      }, { threshold: 0 });
      obs.observe(ctaRow);
    } else {
      bar.classList.add('is-visible'); // graceful fallback
      document.body.classList.add('klistel-sticky-on');
      liftWhatsAppFab(true);
    }

    // Wire up clickable size text → bottom sheet.
    setupStickySizeChange();
  }

  // Open a bottom sheet to change size from the sticky bar. Mirrors the real
  // .variant-input radios, so selecting a pill triggers Impulse's variant
  // change handler (updates price, URL, selected radio, etc).
  function setupStickySizeChange() {
    var bar = document.querySelector('.klistel-sticky-bar');
    if (!bar) return;
    var sizeEl = bar.querySelector('.klistel-sticky-size');
    if (!sizeEl) return;
    if (sizeEl.dataset.klistelSizeWired === '1') return;
    sizeEl.dataset.klistelSizeWired = '1';

    sizeEl.classList.add('klistel-sticky-size--clickable');
    sizeEl.setAttribute('role', 'button');
    sizeEl.setAttribute('tabindex', '0');
    sizeEl.setAttribute('aria-label', 'Change size');

    function closeSheet() {
      var sheet = document.getElementById('klistel-size-sheet');
      if (!sheet) return;
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function buildSheet() {
      var existing = document.getElementById('klistel-size-sheet');
      if (existing) return existing;

      var overlay = document.createElement('div');
      overlay.id = 'klistel-size-sheet';
      overlay.className = 'klistel-size-sheet';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Select size');
      overlay.innerHTML =
        '<div class="klistel-size-sheet__backdrop"></div>' +
        '<div class="klistel-size-sheet__panel">' +
          '<div class="klistel-size-sheet__handle" aria-hidden="true"></div>' +
          '<div class="klistel-size-sheet__head">' +
            '<div class="klistel-size-sheet__title">Select Size</div>' +
            '<button type="button" class="klistel-size-sheet__close" aria-label="Close">' +
              '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="klistel-size-sheet__grid" data-klistel-size-grid></div>' +
        '</div>';
      document.body.appendChild(overlay);

      var grid = overlay.querySelector('[data-klistel-size-grid]');
      var radios = document.querySelectorAll(
        '.variant-input-wrap[data-handle="size"] input[type="radio"], .variant-input input[type="radio"]'
      );
      radios.forEach(function (input) {
        var labelEl = document.querySelector('label[for="' + input.id + '"]');
        var labelText = labelEl ? labelEl.textContent.trim() : input.value;
        var soldOut = input.disabled || (labelEl && /sold/i.test(labelEl.className));

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'klistel-size-sheet__pill';
        if (input.checked) btn.classList.add('is-active');
        if (soldOut) {
          btn.classList.add('is-disabled');
          btn.disabled = true;
        }
        btn.textContent = labelText;
        btn.setAttribute('data-input-id', input.id);
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.dispatchEvent(new Event('click', { bubbles: true }));
          grid.querySelectorAll('.klistel-size-sheet__pill').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          setTimeout(closeSheet, 180);
        });
        grid.appendChild(btn);
      });

      overlay.querySelector('.klistel-size-sheet__backdrop').addEventListener('click', closeSheet);
      overlay.querySelector('.klistel-size-sheet__close').addEventListener('click', closeSheet);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSheet();
      });

      return overlay;
    }

    function openSheet() {
      var sheet = buildSheet();
      sheet.querySelectorAll('.klistel-size-sheet__pill').forEach(function (b) {
        var id = b.getAttribute('data-input-id');
        var input = document.getElementById(id);
        b.classList.toggle('is-active', !!(input && input.checked));
      });
      sheet.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    sizeEl.addEventListener('click', openSheet);
    sizeEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openSheet();
      }
    });
  }


  // ----------------------------------------------------------------
  // [CART CTL] Complete the Look upsell inside the cart drawer.
  // When the Impulse cart drawer opens, inject a horizontal scroller
  // of 3 CTL products (image + title + price + Add) above the footer.
  // Reuses resolveCompleteLookList() so the same products that show on
  // the PDP also appear in the cart. Products already in cart are hidden.
  // (Self-contained per Rule #6 — no theme changes needed.)
  // ----------------------------------------------------------------
  var KL_CART_CTL_BOUND = false;
  function setupCartCompleteTheLook() {
    if (KL_CART_CTL_BOUND) return;
    KL_CART_CTL_BOUND = true;

    var html = document.documentElement;
    var lastOpen = html.classList.contains('js-drawer-open');

    function tryInject() {
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        var drawer = document.querySelector('#CartDrawer');
        var scrollable = drawer && drawer.querySelector('.drawer__scrollable');
        if (scrollable) {
          clearInterval(iv);
          injectCartCTL(drawer, scrollable);
        }
        if (attempts > 20) clearInterval(iv); // ~3s max
      }, 150);
    }

    new MutationObserver(function () {
      var isOpen = html.classList.contains('js-drawer-open');
      if (isOpen && !lastOpen) tryInject();
      lastOpen = isOpen;
    }).observe(html, { attributes: true, attributeFilter: ['class'] });

    // Also re-inject after Impulse rebuilds the drawer (cart:build event).
    document.addEventListener('cart:build', function () {
      // Drop the existing block so we re-render with fresh in-cart filter.
      var existing = document.getElementById('klistel-cart-ctl');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      if (html.classList.contains('js-drawer-open')) tryInject();
    });

    // If drawer is already open on init, inject now.
    if (lastOpen) tryInject();
  }

  function injectCartCTL(drawer, scrollable) {
    if (drawer.querySelector('#klistel-cart-ctl')) return;

    var items = resolveCompleteLookList();
    if (!items || !items.length) return;

    // Filter out items already in cart, then render.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) {
          if (it && it.variant_id) inCart[String(it.variant_id)] = true;
          if (it && it.id) inCart[String(it.id)] = true;
        });
        var available = items.filter(function (it) {
          return it.variantId && !inCart[String(it.variantId)] && it.available !== false;
        });
        if (!available.length) return;
        renderCartCTL(drawer, scrollable, available);
      });
  }

  function renderCartCTL(drawer, scrollable, items) {
    if (drawer.querySelector('#klistel-cart-ctl')) return;

    var section = document.createElement('div');
    section.id = 'klistel-cart-ctl';
    section.className = 'klistel-cart-ctl';

    // Header: title + decorative ornament + "View more" link on the right
    var head = document.createElement('div');
    head.className = 'klistel-cart-ctl__head';

    var titleWrap = document.createElement('div');
    titleWrap.className = 'klistel-cart-ctl__head-left';

    var titleH = document.createElement('h3');
    titleH.className = 'klistel-cart-ctl__heading';
    titleH.textContent = 'Complete the look';
    titleWrap.appendChild(titleH);

    // Ornament: thin line + diamond + thin line (Klistel V1 motif)
    var orn = document.createElement('span');
    orn.className = 'klistel-cart-ctl__ornament';
    orn.setAttribute('aria-hidden', 'true');
    orn.innerHTML = '<span class="klistel-cart-ctl__ornament-line"></span><svg viewBox="0 0 12 12" width="10" height="10" fill="currentColor"><path d="M6 0 L12 6 L6 12 L0 6 Z"/></svg><span class="klistel-cart-ctl__ornament-line"></span>';
    titleWrap.appendChild(orn);

    head.appendChild(titleWrap);

    var more = document.createElement('a');
    more.className = 'klistel-cart-ctl__more';
    more.href = '/collections/all';
    more.innerHTML = 'View more <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    head.appendChild(more);

    section.appendChild(head);

    var tag = document.createElement('div');
    tag.className = 'klistel-cart-ctl__tagline';
    tag.textContent = 'Style it. Love it. Complete it.';
    section.appendChild(tag);

    var track = document.createElement('div');
    track.className = 'klistel-cart-ctl__list';
    section.appendChild(track);

    items.forEach(function (it) {
      var card = document.createElement('div');
      card.className = 'klistel-cart-ctl__item';

      var link = it.handle ? ('/products/' + it.handle) : '#';

      var imgWrap = document.createElement('a');
      imgWrap.className = 'klistel-cart-ctl__img';
      imgWrap.href = link;
      if (it.img) {
        var img = document.createElement('img');
        img.src = it.img;
        img.alt = it.title || '';
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      card.appendChild(imgWrap);

      var info = document.createElement('div');
      info.className = 'klistel-cart-ctl__info';

      var titleEl = document.createElement('a');
      titleEl.className = 'klistel-cart-ctl__title';
      titleEl.href = link;
      titleEl.textContent = it.title || '';
      info.appendChild(titleEl);

      var priceEl = document.createElement('div');
      priceEl.className = 'klistel-cart-ctl__price';
      priceEl.textContent = it.price ? inr(it.price) : (it.priceFormatted || '');
      info.appendChild(priceEl);

      card.appendChild(info);

      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'klistel-cart-ctl__add';
      addBtn.setAttribute('aria-label', 'Add ' + (it.title || 'item') + ' to cart');
      addBtn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg><span>Add</span>';
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!it.variantId) { showToast('Item unavailable'); return; }
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        var origHTML = addBtn.innerHTML;
        addBtn.innerHTML = '<span class="klistel-cart-ctl__spin"></span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: it.variantId, quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        }).then(function () {
          showToast('Added to cart');
          // Refresh Impulse cart drawer — this will trigger our cart:build
          // listener which re-renders the CTL block (so this item drops off).
          try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
          addBtn.innerHTML = origHTML;
          showToast('Could not add — please try again');
        });
      });
      card.appendChild(addBtn);

      track.appendChild(card);
    });

    // Append at the END of scrollable so it sits above the footer naturally.
    scrollable.appendChild(section);
  }


  // ----------------------------------------------------------------
  // [TITLE META] V1 title region — adds two things the live theme
  // doesn't render:
  //   1) a reviews row ABOVE the product title (rating + gold stars +
  //      "N reviews" link that jumps to the on-page reviews section)
  //   2) a gray subtitle line BELOW the product title.
  //
  // Per Vivek: the reviews row is a STATIC placeholder for now
  // (4.7 / 7 reviews) until the store has real reviews. The subtitle
  // uses a default for this product now, but is built to auto-swap
  // per product later WITHOUT a code change: it reads, in order,
  //   a) a [data-klistel-subtitle] element/attr on the page, or
  //   b) a global window.KLISTEL_SUBTITLE string, or
  //   c) the default text below.
  // This is CSS/JS-only — the live product data is never written to.
  // (Self-contained per Rule #6.)
  var KL_REVIEW_RATING = '4.7';   // static placeholder rating
  var KL_REVIEW_COUNT  = '7';     // static placeholder review count
  // No hardcoded default. If a product has no `custom.subtitle` metafield
  // set in Shopify admin, the subtitle line is simply not inserted.
  // This prevents every product from showing the same hardcoded text.
  var KL_SUBTITLE_DEFAULT = '';

  function starSvg() {
    // Single filled star, matches the V1 gold star path exactly.
    return '<svg viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M10 1l2.39 4.84 5.34.78-3.87 3.77.91 5.32L10 13.27l-4.77 2.51.91-5.32L2.27 6.69l5.34-.78z"/>' +
      '</svg>';
  }

  // Read the per-product subtitle from a Shopify metafield.
  //
  // Uses the Shopify-standard "Product subtitle" metafield definition
  // (namespace `descriptors`, key `subtitle`). A small Liquid snippet in
  // sections/product-template.liquid renders it into the page as:
  //   <meta name="klistel:subtitle" content="{{ product.metafields.descriptors.subtitle }}">
  //
  // We also support `data-klistel-subtitle="..."` on the title element as a
  // fallback injection point.
  function readSubtitleFromMetafield() {
    // 1) <meta name="klistel:subtitle" content="..."> (preferred, set via Liquid)
    var metaTag = document.querySelector('meta[name="klistel:subtitle"]');
    if (metaTag) {
      var v = (metaTag.getAttribute('content') || '').trim();
      if (v) return v;
    }
    // 2) data attribute on the title (alternative injection point)
    var titleEl = document.querySelector('.product-single__title, .product__title');
    if (titleEl) {
      var dv = (titleEl.getAttribute('data-klistel-subtitle') || '').trim();
      if (dv) return dv;
    }
    return '';
  }

  function resolveSubtitle() {
    // a) explicit per-product hook anywhere on the page (manual override)
    var hook = document.querySelector('[data-klistel-subtitle]:not(.product-single__title):not(.product__title)');
    if (hook) {
      var v = (hook.getAttribute('data-klistel-subtitle') || hook.textContent || '').trim();
      if (v) return v;
    }
    // b) product metafield descriptors.subtitle (the clean, editable path)
    //    Shopify admin â†’ Products â†’ <product> â†’ Metafields â†’ Product subtitle
    var fromMeta = readSubtitleFromMetafield();
    if (fromMeta) return fromMeta;
    // c) global string a theme/section could set
    if (typeof window.KLISTEL_SUBTITLE === 'string' && window.KLISTEL_SUBTITLE.trim()) {
      return window.KLISTEL_SUBTITLE.trim();
    }
    // d) default fallback for products that have not had a subtitle written yet
    return KL_SUBTITLE_DEFAULT;
  }

  // Place the reviews badge BELOW the price block. If the price block has not
  // rendered yet (Impulse sometimes injects it after page load), we leave the
  // badge where it is for now; setupPriceRow() calls this again once the price
  // exists so the badge reliably ends up under the price.
  function placeReviewsBadge() {
    var badge = document.querySelector('.klistel-meta-badge');
    if (!badge) return;
    var priceBlock = document.querySelector('.product-block--price');
    if (priceBlock && priceBlock.parentNode) {
      badge.classList.add('klistel-meta-badge--below-price');
      // Only move if it is not already the price block's next sibling.
      if (priceBlock.nextSibling !== badge) {
        priceBlock.parentNode.insertBefore(badge, priceBlock.nextSibling);
      }
    }
  }

  function setupTitleMeta() {
    var title = document.querySelector('.product-single__title, .product__title');
    if (!title) return;

    // ---- 1) Reviews row (created once, then placed BELOW the price) ----
    if (!document.querySelector('.klistel-meta-badge')) {
      // Clicking the badge smooth-scrolls to our "Words From Our Mothers"
      // reviews section (#klistel-reviews), which setupSocialProof injects
      // above "You May Also Like". We attach a JS handler (not just an href)
      // so the scroll is smooth and we can wait for the section to exist if
      // the user clicks before it has rendered.
      var badge = document.createElement('a');
      badge.className = 'klistel-meta-badge';
      badge.setAttribute('href', '#klistel-reviews');
      badge.setAttribute('aria-label', 'Jump to ' + KL_REVIEW_COUNT + ' customer reviews');
      badge.innerHTML =
        '<span class="klistel-rating-num">' + KL_REVIEW_RATING + '</span>' +
        '<span class="klistel-stars-inline">' +
          starSvg() + starSvg() + starSvg() + starSvg() + starSvg() +
        '</span>' +
        '<span class="klistel-review-count">' + KL_REVIEW_COUNT + ' reviews</span>';
      badge.addEventListener('click', function (ev) {
        var target = document.getElementById('klistel-reviews');
        if (!target) {
          // Section not injected yet — make sure it is, then scroll.
          try { setupSocialProof(); } catch (e) {}
          target = document.getElementById('klistel-reviews');
        }
        if (target) {
          ev.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      // Insert next to the title first as a safe anchor; placeReviewsBadge()
      // immediately relocates it below the price when the price block exists.
      title.parentNode.insertBefore(badge, title);
    }
    placeReviewsBadge();

    // ---- 2) Subtitle BELOW the title (insert once) ----
    // Only inject if the product actually has a subtitle set in admin via
    // the `custom.subtitle` metafield (read from <meta name="klistel:subtitle">).
    // No metafield => no subtitle line at all (cleaner than a hardcoded default).
    if (!document.querySelector('.klistel-product-subtitle')) {
      var subText = resolveSubtitle();
      if (subText) {
        var sub = document.createElement('p');
        sub.className = 'klistel-product-subtitle';
        sub.textContent = subText;
        if (title.nextSibling) {
          title.parentNode.insertBefore(sub, title.nextSibling);
        } else {
          title.parentNode.appendChild(sub);
        }
      }
    }
  }

  // ----------------------------------------------------------------
  // [PRICE ROW] V1 price line — ONE price + "Tax included" + the Free
  // Shipping pill, all on a single row.
  //
  // Shopify/Liquid note: this product has a compare-at price set in the
  // admin (₹5,400 “was” vs ₹4,900 “now”), so Impulse's theme renders
  // THREE elements — a strikethrough compare price, the sale price, and a
  // “Save ₹500” savings tag — because Liquid shows them whenever
  // compare_at_price > price. We CANNOT remove the compare-at price
  // without editing live product data (off-limits), so instead we HIDE
  // the strikethrough + savings via CSS and keep only the real price.
  // Here in JS we (a) tidy the long tax/shipping policy line down to a
  // compact “Tax included” note and (b) move the native Free-Shipping
  // Sales-Point pill INTO the price block so it sits on the same row.
  // Self-contained per Rule #6 — no theme/product files touched.
  function setupPriceRow() {
    var priceBlock = document.querySelector('.product-block--price');
    if (!priceBlock) return;

    // Flag the row so CSS can lay it out as one flex line.
    priceBlock.classList.add('klistel-price-row');

    // (a) Collapse the verbose policies line ("Tax included. Shipping
    //     calculated at checkout.") into a compact inline "Tax included".
    //     We keep the element (theme owns it) and just swap its text.
    var policies = priceBlock.querySelector('.product__policies');
    if (policies && !policies.classList.contains('klistel-tax-note')) {
      policies.classList.add('klistel-tax-note');
      policies.textContent = 'Tax included';
    }

    // (b) Move the Free-Shipping Sales-Point pill onto the price row.
    //     The pill is the theme's native Sales Point block; it normally
    //     sits in its own block below. We relocate it right after the
    //     tax note so the row reads: ₹4,900  ·  Tax included  ·  [pill].
    if (!priceBlock.querySelector('.klistel-moved-shippill')) {
      var pill = document.querySelector('.product-single__sales-point, .sales-point');
      if (pill && !priceBlock.contains(pill)) {
        pill.classList.add('klistel-moved-shippill');
        priceBlock.appendChild(pill);
      }
    }

    // (c) Rewrite the Sales-Point text from "FREE PAN INDIA" (or similar
    //     uppercase shouty variant) to the calmer "Free delivery across
    //     India" copy. We only touch the human-readable text node, leaving
    //     the icon/SVG sibling untouched. Idempotent via a data flag.
    var movedPill = priceBlock.querySelector('.klistel-moved-shippill');
    if (movedPill && !movedPill.dataset.klistelTextRewritten) {
      // Find the text-carrying node: prefer a nested span/strong/em with
      // text, else the pill's own direct text node.
      var textHost = null;
      var candidates = movedPill.querySelectorAll('span, strong, em, p, div');
      for (var i = 0; i < candidates.length; i++) {
        var t = (candidates[i].textContent || '').trim();
        if (t && /free|pan|india|shipping|delivery/i.test(t)) {
          textHost = candidates[i];
          break;
        }
      }
      if (textHost) {
        textHost.textContent = 'Free delivery pan India';
      } else {
        // Fallback: walk direct child text nodes of the pill itself.
        for (var j = 0; j < movedPill.childNodes.length; j++) {
          var n = movedPill.childNodes[j];
          if (n.nodeType === 3 && (n.nodeValue || '').trim()) {
            n.nodeValue = 'Free delivery pan India';
            break;
          }
        }
      }
      movedPill.dataset.klistelTextRewritten = '1';
    }

    // Now that the price block definitely exists, make sure the reviews row
    // sits directly below it (relocates from its title-anchored fallback spot).
    placeReviewsBadge();
  }

  // The floating WhatsApp button is a 3rd-party chat widget (Zoko) injected at
  // runtime as a fixed bottom-right element. It can be an <iframe>, a <div>, or
  // an <a> — and it carries a near-max z-index, so it paints ON TOP of our
  // sticky ADD-TO-CART bar (z-index 200). We therefore physically lift the
  // widget element's inline bottom above the bar whenever the bar is showing,
  // and drop it back down when hidden. We detect it by ANY of: WhatsApp/Zoko
  // signal in attrs, OR a small fixed bottom-right node (classic FAB shape).
  // Self-contained per Rule #6 — no theme/app files touched.
  var KL_FAB = null;            // cached widget element once found
  var KL_FAB_REST = '20px';     // its original resting bottom (captured once)

  function looksLikeFab(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.closest && el.closest('.klistel-sticky-bar')) return false; // never our own bar
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed') return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var bottomRight = (r.right > window.innerWidth - 260) && (r.bottom > window.innerHeight - 260);
    var fabSized = r.width <= 200 && r.height <= 200;
    var attrs = ((el.id || '') + ' ' + (el.className || '').toString() + ' ' +
                 (el.getAttribute('src') || '') + ' ' + (el.getAttribute('href') || '') + ' ' +
                 (el.getAttribute('title') || '') + ' ' + (el.getAttribute('aria-label') || '')).toLowerCase();
    var signal = /zoko|whatsapp|wa\.me|chat-?widget|wa-?widget|wa-?btn/.test(attrs);
    return signal || (bottomRight && fabSized);
  }

  function findWhatsAppFab() {
    if (KL_FAB && document.body.contains(KL_FAB)) return KL_FAB;
    // 0) FAST PATH — Zoko's real fixed container, confirmed via live DOM inspection:
    //    <div id="zoko-..."> > <div class="reset23947hdfjue8934" style="position:fixed;bottom:50px;right:10px">
    //    This .reset... div is the element whose `bottom` actually moves the
    //    whole widget, so we grab it directly. The hashed class is Zoko's; if
    //    they ever change it, fall through to the generic detection below.
    var zokoHost = document.querySelector('[id^="zoko-"]');
    if (zokoHost) {
      // The fixed-positioned div inside the zoko host is the widget container.
      // Prefer the known hashed class; else find the first fixed descendant.
      KL_FAB = zokoHost.querySelector('.reset23947hdfjue8934');
      if (!KL_FAB) {
        var divs = zokoHost.querySelectorAll('div');
        for (var z = 0; z < divs.length; z++) {
          if (window.getComputedStyle(divs[z]).position === 'fixed') { KL_FAB = divs[z]; break; }
        }
      }
      if (KL_FAB) {
        var zb = window.getComputedStyle(KL_FAB).bottom;
        if (zb && zb !== 'auto') KL_FAB_REST = zb;
        return KL_FAB;
      }
    }
    // 1) Prefer an explicit WhatsApp/Zoko signal anywhere on the page.
    var nodes = document.querySelectorAll(
      'iframe[src*="zoko" i], [class*="zoko" i], [id*="zoko" i], ' +
      '[class*="reset23947" i], ' +
      'a[href*="wa.me"], [class*="whatsapp" i], [id*="whatsapp" i], ' +
      '[class*="chat-widget" i], [class*="wa-widget" i]');
    for (var i = 0; i < nodes.length; i++) {
      // Walk up to the fixed-position container that actually positions it.
      var el = nodes[i];
      while (el && el !== document.body) {
        if (window.getComputedStyle(el).position === 'fixed') break;
        el = el.parentElement;
      }
      if (el && el !== document.body && looksLikeFab(el)) { KL_FAB = el; break; }
    }
    // 2) Fallback: any small fixed bottom-right node directly under <body>.
    if (!KL_FAB) {
      var kids = document.body.children;
      for (var j = 0; j < kids.length; j++) {
        if (looksLikeFab(kids[j])) { KL_FAB = kids[j]; break; }
      }
    }
    if (KL_FAB) {
      var b = window.getComputedStyle(KL_FAB).bottom;
      if (b && b !== 'auto') KL_FAB_REST = b;   // remember original resting spot
    }
    return KL_FAB;
  }

  function liftWhatsAppFab(lift) {
    var fab = findWhatsAppFab();
    if (!fab) return;
    // Measure the real sticky-bar height at runtime so the FAB sits a
    // comfortable margin ABOVE it. Falls back to 73px if not measurable yet.
    var barH = 73;
    var sb = document.querySelector('.klistel-sticky-bar');
    if (sb) {
      var h = sb.getBoundingClientRect().height;
      if (h) barH = h;
    }
    // IMPORTANT: Zoko's visible icon is an absolutely-positioned <img> INSIDE
    // the fixed container, carrying its own `bottom` (~50px). So the icon's
    // real distance from the viewport bottom = container.bottom + imgOffset.
    // To park the icon ~16px above the bar we must SUBTRACT that img offset
    // from the container's bottom, else it floats ~50px too high.
    var imgOffset = 0;
    var icon = fab.querySelector('img');
    if (icon) {
      var ib = parseFloat(window.getComputedStyle(icon).bottom);
      if (!isNaN(ib)) imgOffset = ib;
    }
    var wantIconBottom = Math.round(barH + 16);          // icon should clear bar by 16px
    var liftPx = Math.max(wantIconBottom - imgOffset, 8); // container bottom; never below 8px
    fab.style.setProperty('bottom', lift ? (liftPx + 'px') : KL_FAB_REST, 'important');
    fab.style.setProperty('transition', 'bottom .25s ease', 'important');
  }

  // The widget is injected late and may re-render. Poll briefly to catch it,
  // then keep a MutationObserver so any later injection is also handled.
  function watchWhatsAppFab() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (findWhatsAppFab()) {
        liftWhatsAppFab(document.body.classList.contains('klistel-sticky-on'));
        clearInterval(iv);
      } else if (tries >= 50) {
        clearInterval(iv); // ~10s then give up polling
      }
    }, 200);
    // Persistent safety net: if the widget mounts/remounts later, re-apply.
    if ('MutationObserver' in window && !window.__klFabObs) {
      window.__klFabObs = new MutationObserver(function () {
        if (findWhatsAppFab()) {
          liftWhatsAppFab(document.body.classList.contains('klistel-sticky-on'));
        }
      });
      window.__klFabObs.observe(document.body, { childList: true, subtree: false });
    }
  }

  // v7 â€” Watch the product form for Shopify Section Rendering API re-paints
  // (variant change, recommendations refresh, theme preview hot-reload). When
  // Impulse re-renders the form, our injected wrappers vanish from the new
  // HTML and we need to re-apply them so every PDP stays consistent.
  function watchProductForm() {
    if (!('MutationObserver' in window) || window.__klFormObs) return;
    var form = document.querySelector('form.product-single__form');
    if (!form) return;
    var pending = false;
    window.__klFormObs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // Debounce to one re-apply per animation frame.
      requestAnimationFrame(function () {
        pending = false;
        try { moveSizeChartLink(); } catch (e) {}
        try { setupCtaRow(); } catch (e) {}
        try { setupTailorCta(); } catch (e) {}
        try { setupPriceRow(); } catch (e) {}
      });
    });
    window.__klFormObs.observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'complete') {
    waitForFlickityThenResize();
    moveSizeChartLink();
    watchProductForm();
    setupCtaRow();
    setupTailorCta();
    setupTitleMeta();
    setupPriceRow();
    setupInfoBlocks();
    collapseTabsOnce();
    setupSocialProof();
    setupCompleteLook();
    setupStickyBar();
    setupCartCompleteTheLook();
    setupFooter();
    watchWhatsAppFab();
  } else {
    window.addEventListener('load', function () {
      waitForFlickityThenResize();
      moveSizeChartLink();
      watchProductForm();
      setupCtaRow();
      setupTailorCta();
      setupTitleMeta();
      setupPriceRow();
      setupInfoBlocks();
      collapseTabsOnce();
      setupSocialProof();
      setupCompleteLook();
      setupStickyBar();
      setupCartCompleteTheLook();
      setupFooter();
      watchWhatsAppFab();
    });
  }
  // Also try on DOMContentLoaded in case blocks render before load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      moveSizeChartLink();
      watchProductForm();
      setupCtaRow();
      setupTailorCta();
      setupTitleMeta();
      setupPriceRow();
      setupInfoBlocks();
      collapseTabsOnce();
      setupSocialProof();
      setupCompleteLook();
      setupStickyBar();
      setupCartCompleteTheLook();
      setupFooter();
    });
  } else {
    moveSizeChartLink();
    setupCtaRow();
    setupTailorCta();
    setupTitleMeta();
    setupPriceRow();
    setupInfoBlocks();
    collapseTabsOnce();
    setupSocialProof();
    setupCompleteLook();
    setupStickyBar();
    setupCartCompleteTheLook();
    setupFooter();
  }

  // v7.8 — watchdog: keep retrying setupTailorCta + setupInfoBlocks for
  // a short window after page interaction, then settle. This catches the
  // race where Impulse renders the product meta block AFTER our first
  // pass (causing the tracker to drop above the size selector). We poll
  // for up to 6 seconds at 250 ms, then stop.
  (function klRepositionWatchdog() {
    var ticks = 0;
    var maxTicks = 24; // 24 * 250ms = 6s
    var iv = setInterval(function () {
      ticks++;
      try {
        if (typeof setupCtaRow === 'function') setupCtaRow();
        if (typeof setupTailorCta === 'function') setupTailorCta();
        if (typeof setupInfoBlocks === 'function') setupInfoBlocks();
        relocateSizeRowIfNeeded();
        relocateInfoBlocksIfNeeded();
        relocateWhyMomsIfNeeded();
      } catch (e) { /* ignore */ }
      var wrap = document.querySelector('.klistel-info-blocks');
      var btn = document.querySelector('.klistel-tailor-trigger');
      var fabric = document.querySelector('.kl-fabric');
      var fabricBlock = fabric ? fabric.closest('.product-block') : null;
      var sizeRow = document.querySelector('.klistel-size-row');
      var ctaRow = document.querySelector('.klistel-cta-row');
      var trackerOK = wrap && btn && btn.nextElementSibling === wrap;
      var whyMomsOK = !fabricBlock || (wrap && wrap.nextElementSibling === fabricBlock);
      var sizeOK = !sizeRow || !ctaRow || ctaRow.previousElementSibling === sizeRow;
      // settle once tracker AND why-moms AND size row are correctly placed
      if (trackerOK && whyMomsOK && sizeOK) {
        clearInterval(iv);
      } else if (ticks >= maxTicks) {
        clearInterval(iv);
      }
    }, 250);
  })();

  // Re-measure on viewport width changes (rotation, resize), debounced.
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(resizeKlistelSliders, 200);
  });
})();


/* ============================================================
   [PDP-CAROUSEL-HEIGHT-LOCK] v2 — more permissive guard
   ============================================================ */
(function lockKlistelCarouselHeightModule() {
  function init() {
    if (window.innerWidth > 768) return;
    // Run if EITHER the body class OR a .product-slideshow exists
    if (!document.querySelector('.product-slideshow')) return;

    var stripPadding = function () {
      var wraps = document.querySelectorAll('.product-slideshow .image-wrap');
      for (var i = 0; i < wraps.length; i++) {
        wraps[i].style.paddingBottom = '0';
        wraps[i].style.height = '113vw';
      }
      var vp = document.querySelector('.product-slideshow .flickity-viewport');
      if (vp) vp.style.height = '113vw';
      var slides = document.querySelectorAll('.product-slideshow .product-main-slide');
      for (var j = 0; j < slides.length; j++) {
        slides[j].style.height = '113vw';
      }
      // Debug breadcrumb — visible in DevTools console
      console.log('[klistel] carousel locked, wraps:', wraps.length);
    };

    stripPadding();
    setTimeout(stripPadding, 100);
    setTimeout(stripPadding, 500);
    setTimeout(stripPadding, 1500);
    setTimeout(stripPadding, 3000);

    var slideshow = document.querySelector('.product-slideshow');
    if (slideshow && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(stripPadding);
      mo.observe(slideshow, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true
      });
    }

    window.addEventListener('resize', stripPadding);
    window.addEventListener('load', stripPadding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ============================================================
   [20] JUNE 21, 2026 — 6-ITEM UPDATE PACK (JS)
   ------------------------------------------------------------
   (1) Wrap every ₹ glyph in <span class="klistel-rupee">
       so it renders in Cormorant serif (digits stay DM Sans).
   (2) Wire Klistel hearts to Wishlist Hero app — uses the
       documented "wishlist-hero-add-to-custom-element" event.
   (3) Swap footer address to the new Dundahera location and
       wrap it in .klistel-address-text for multi-line styling.
   ============================================================ */
(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     (1) ₹ → Cormorant serif
     ────────────────────────────────────────────────────────── */
  var RUPEE = '\u20B9';
  // Skip nodes already wrapped, plus script/style/code blocks.
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, CODE: 1 };

  function wrapRupeeInTextNode(node) {
    var text = node.nodeValue;
    if (text.indexOf(RUPEE) === -1) return;
    // Avoid re-wrapping if parent is already .klistel-rupee
    if (node.parentNode && node.parentNode.classList &&
        node.parentNode.classList.contains('klistel-rupee')) return;

    var frag = document.createDocumentFragment();
    var lastIdx = 0;
    for (var i = 0; i < text.length; i++) {
      if (text.charAt(i) === RUPEE) {
        if (i > lastIdx) {
          frag.appendChild(document.createTextNode(text.substring(lastIdx, i)));
        }
        var span = document.createElement('span');
        span.className = 'klistel-rupee';
        span.textContent = RUPEE;
        frag.appendChild(span);
        lastIdx = i + 1;
      }
    }
    if (lastIdx < text.length) {
      frag.appendChild(document.createTextNode(text.substring(lastIdx)));
    }
    node.parentNode.replaceChild(frag, node);
  }

  function walkAndWrap(root) {
    if (!root || !root.nodeType) return;
    // Defensive: if root itself is .klistel-rupee, skip
    if (root.nodeType === 1 && root.classList && root.classList.contains('klistel-rupee')) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf(RUPEE) === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        while (p && p.nodeType === 1) {
          if (SKIP_TAGS[p.tagName]) return NodeFilter.FILTER_REJECT;
          if (p.classList && p.classList.contains('klistel-rupee')) return NodeFilter.FILTER_REJECT;
          p = p.parentNode;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(wrapRupeeInTextNode);
  }

  function initRupeeWrap() {
    walkAndWrap(document.body);

    // Observe additions (cart drawer, AJAX price updates, dynamic sections).
    if (typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        // Newly added nodes
        for (var j = 0; j < m.addedNodes.length; j++) {
          var added = m.addedNodes[j];
          if (added.nodeType === 1) walkAndWrap(added);
          else if (added.nodeType === 3) wrapRupeeInTextNode(added);
        }
        // Text content change on existing node (e.g. price re-render in place)
        if (m.type === 'characterData' && m.target && m.target.nodeType === 3) {
          wrapRupeeInTextNode(m.target);
        }
      }
    });
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ──────────────────────────────────────────────────────────
     (2) Wishlist Hero hookup
     ────────────────────────────────────────────────────────── */
  // Read product data from the page so we can pass it to WLH.
  function readProductMeta() {
    var meta = {
      id: null,
      handle: null,
      title: null,
      link: location.pathname,
      variantId: null,
      price: null,
      image: null
    };
    // Shopify analytics / ShopifyAnalytics.meta.product
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        var p = window.ShopifyAnalytics.meta.product;
        meta.id = p.id || null;
        meta.variantId = (p.variants && p.variants[0] && p.variants[0].id) || null;
      }
    } catch (e) {}

    // Theme's preloaded product JSON (Impulse: window.product or [data-product-json])
    try {
      var jsonNode = document.querySelector('[data-product-json]');
      if (jsonNode) {
        var pj = JSON.parse(jsonNode.textContent || jsonNode.innerText || '{}');
        meta.id        = meta.id || pj.id;
        meta.handle    = meta.handle || pj.handle;
        meta.title     = meta.title || pj.title;
        meta.image     = meta.image || (pj.featured_image || (pj.images && pj.images[0]));
        meta.variantId = meta.variantId || (pj.variants && pj.variants[0] && pj.variants[0].id);
        meta.price     = meta.price || (pj.price ? (pj.price / 100).toFixed(2) : null);
      }
    } catch (e) {}

    // Selected variant from URL ?variant=
    try {
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m) meta.variantId = m[1];
    } catch (e) {}

    // Build absolute link if we have a handle
    if (meta.handle && location.pathname.indexOf('/products/') === -1) {
      meta.link = '/products/' + meta.handle;
    }
    return meta;
  }

  function ensureWLHAttrs(btn, meta) {
    if (!btn) return;
    if (!btn.classList.contains('wishlist-hero-custom-button')) {
      btn.classList.add('wishlist-hero-custom-button');
    }
    if (meta.id        && !btn.getAttribute('data-wlh-id'))        btn.setAttribute('data-wlh-id', meta.id);
    if (meta.link      && !btn.getAttribute('data-wlh-link'))      btn.setAttribute('data-wlh-link', meta.link);
    if (meta.variantId && !btn.getAttribute('data-wlh-variantid')) btn.setAttribute('data-wlh-variantid', meta.variantId);
    if (meta.title     && !btn.getAttribute('data-wlh-name'))      btn.setAttribute('data-wlh-name', meta.title);
    if (meta.image     && !btn.getAttribute('data-wlh-image'))     btn.setAttribute('data-wlh-image', meta.image);
    if (meta.price     && !btn.getAttribute('data-wlh-price'))     btn.setAttribute('data-wlh-price', meta.price);
    if (!btn.getAttribute('data-wlh-mode')) btn.setAttribute('data-wlh-mode', 'icon_only');
    if (!btn.getAttribute('data-wlh-view')) btn.setAttribute('data-wlh-view', 'ProductPage');
    if (!btn.getAttribute('data-wlh-variantlistener')) btn.setAttribute('data-wlh-variantlistener', 'product-page');
  }

  function dispatchWLHRegister(btn) {
    if (!btn || btn.dataset.wlhRegistered === '1') return;
    try {
      var ev = new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn });
      document.dispatchEvent(ev);
      btn.dataset.wlhRegistered = '1';
    } catch (e) {
      console.warn('[klistel] WLH dispatch failed:', e);
    }
  }

  function setupWishlistHero() {
    var meta = readProductMeta();
    var hearts = document.querySelectorAll(
      'button.klistel-wishlist-btn, button.klistel-sticky-like'
    );
    if (!hearts.length) return;

    hearts.forEach(function (btn) {
      ensureWLHAttrs(btn, meta);
      dispatchWLHRegister(btn);
    });

    // Re-bind on variant change so price/variantId update
    try {
      document.addEventListener('variant:change', function (e) {
        if (!e.detail || !e.detail.variant) return;
        var v = e.detail.variant;
        hearts.forEach(function (b) {
          b.setAttribute('data-wlh-variantid', v.id);
          if (v.price) b.setAttribute('data-wlh-price', (v.price / 100).toFixed(2));
        });
      });
    } catch (e) {}
  }

  // Retry shortly because the Wishlist Hero embed script may load slightly
  // after our IIFE. Multiple attempts ensure the CustomEvent is heard.
  function setupWishlistHeroRetry() {
    setupWishlistHero();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      setupWishlistHero();
      if (tries >= 5) clearInterval(iv);
    }, 800);
  }

  /* ──────────────────────────────────────────────────────────
     (3) Footer address swap → new Dundahera address
     ────────────────────────────────────────────────────────── */
  // No hard <br> — let the .klistel-address-text width: 100% column wrap
  // naturally so the address fits in ≤3 lines.
  var NEW_ADDRESS_HTML =
    '17 &amp; 18, First Floor, Vats Complex, opposite Sarita Handa, ' +
    'Sector 20, Udyog Vihar Phase 1, Dundahera, Gurgaon 122016';

  function swapFooterAddress() {
    var links = document.querySelectorAll('.site-footer.klistel-footer a.klistel-contact-link');
    if (!links.length) return false;
    var swapped = false;
    links.forEach(function (a) {
      // Find the leading text node(s) that contain the old address.
      // The link has structure: <svg> <img> [TEXT NODES...]
      var hasOldAddress = (a.textContent || '').indexOf('92 Basement') !== -1
                       || (a.textContent || '').indexOf('Huda Main Market') !== -1
                       || (a.textContent || '').indexOf('Sector 23') !== -1;

      // Skip phone (tel:) and email (mailto:) links — only swap the address one
      var href = a.getAttribute('href') || '';
      var isContactLink = href === '#' || href.indexOf('map') !== -1 || hasOldAddress;
      if (!hasOldAddress && !isContactLink) return;
      // Also require this to be the address-style row (not phone/mail)
      if (href.indexOf('tel:') === 0 || href.indexOf('mailto:') === 0) return;
      if (a.dataset.klistelAddressSwapped === '1') return;

      // Remove all existing text nodes (keep <svg> and <img>)
      var toRemove = [];
      a.childNodes.forEach(function (n) {
        if (n.nodeType === 3) toRemove.push(n);
        else if (n.nodeType === 1 && n.classList && n.classList.contains('klistel-address-text')) {
          toRemove.push(n);
        }
      });
      toRemove.forEach(function (n) { a.removeChild(n); });

      // Append the new address wrapped for multi-line styling
      var span = document.createElement('span');
      span.className = 'klistel-address-text';
      span.innerHTML = NEW_ADDRESS_HTML;
      a.appendChild(span);
      a.dataset.klistelAddressSwapped = '1';
      swapped = true;
    });
    return swapped;
  }

  /* ──────────────────────────────────────────────────────────
     Bootstrap
     ────────────────────────────────────────────────────────── */
  /* ────────────────────────────────────────────────────
     (4) Merge "© 2026 KLISTEL" + "Powered by Shopify" → one line
     ─────────────────────────────────────────────────── */
  function mergeCopyrightLines() {
    var footer = document.querySelector('.site-footer.klistel-footer');
    if (!footer) return false;
    var smalls = footer.querySelectorAll('p.footer__small-text');
    if (smalls.length < 2) return false;

    // Find the two we care about: © line + Powered-by line.
    var copyEl = null, poweredEl = null;
    smalls.forEach(function (p) {
      var t = (p.textContent || '').trim();
      if (!copyEl && /©/.test(t)) copyEl = p;
      if (!poweredEl && /powered\s*by/i.test(t)) poweredEl = p;
    });
    if (!copyEl || !poweredEl) return false;
    if (copyEl.dataset.klistelMerged === 'merged') return true;

    var copyText = (copyEl.textContent || '').trim();
    var poweredText = (poweredEl.textContent || '').trim();
    copyEl.innerHTML = copyText +
      '<span class="klistel-sep" aria-hidden="true">·</span>' +
      poweredText;
    copyEl.dataset.klistelMerged = 'merged';
    poweredEl.dataset.klistelMerged = 'hidden';
    return true;
  }

  function bootUpdates() {
    initRupeeWrap();
    swapFooterAddress();
    mergeCopyrightLines();
    setupWishlistHeroRetry();

    // Re-run footer swaps if the footer is re-rendered (rare but safe).
    if (typeof MutationObserver !== 'undefined') {
      var footer = document.querySelector('.site-footer.klistel-footer');
      if (footer) {
        var fmo = new MutationObserver(function () {
          swapFooterAddress();
          mergeCopyrightLines();
        });
        fmo.observe(footer, { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootUpdates);
  } else {
    bootUpdates();
  }
})();